// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/dist/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/dist/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/dist/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/dist/fonts/Raleway-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/dist/fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/dist/fonts/Raleway-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/dist/fonts/Raleway-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/dist/fonts/Raleway-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/dist/fonts/Raleway-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/dist/fonts/Raleway-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}

@font-face {
  font-family: "Montserrat SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("ttf");
  font-display: swap;
}
@font-face {
  font-family: "Raleway Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}

@font-face {
  font-family: "Raleway SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("ttf");
  font-display: swap;
}

@font-face {
  font-family: "Raleway Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}

@font-face {
  font-family: "Raleway ExtraBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-display: swap;
}
body {
  font-family: "Raleway", sans-serif;
  color: #202020;
  font-size: 14px;
  background-color: #f5f5f5;
  /* it's required since after  razorpay window close, screen vertical scroll freeze  */
  /* overflow: visible !important; */
}

/* body {
  font-family: Arial, Helvetica, sans-serif;
} */
/* body {
  overflow: visible !important;
} */

.bold_font {
  font-family: "Montserrat Bold", sans-serif;
}
.semibold_font {
  /* font-family: "Montserrat SemiBold", sans-serif; */
}
.title-dsn h2 {
  font-size: 50px;
  margin-bottom: 15px;
}
.title-dsn h3 {
  font-size: 35px;
  line-height: 1.5;
}
.title-dsn h4 {
  font-size: 28px;
  line-height: 1.5;
}
.title-dsn h5 {
  font-size: 14px;
  line-height: 1.5;
}

.title-dsn p {
  font-size: 20px;
  line-height: 1.5;
  opacity: 0.6;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.confirmpaybutton {
  background-color: yellow;
  color: #282c34;
  border-width: 10;
  border-color: #29008a;
  border: 2px solid black;
  border-radius: 12px;
}
.carouselbottomborder {
  border-width: 10;
  /* border-color: #29008a; */
  border: 2px solid white;
  border-radius: 12px;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Small devices (Phones, 600pxand down) -- this would display the text at 5.0rem on phones */
@media only screen and (max-width: 600px) {
  html {
    font-size: 13px;
  }
}

/* Large devices (laptops/desktops, 992px and up) -- This would display the text at 10.0rem on laptops and larger screens */
@media only screen and (min-width: 992px) {
  html {
    font-size: 13px;
  }
}

/* .navbar-brand {
  color: green !important;
  font-size: 1.5rem;
} */
.navbar-custom {
  background-color: darkblue !important;
  color: blue !important;
  font-size: 1rem;
}
.navbar-topnav {
  background-color: blueviolet;
}

.anyVerticalScroll {
  height: 800px;
  /* overflow-y: scroll; */
}

.verticalaligncentertd {
  display: flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.buttonhover:hover {
  background-color: blue;
  padding-top: 2px;
  padding-right: 2px;
  padding-left: 2px;
  padding-bottom: 2px;
}

.menuhover:hover {
  /* background-color: transparent !important; */
  background-color: black !important;
  font-weight: bold;
  text-underline-position: below;
  color: white !important;
}
.menufont {
  /* font-family: "muli"; */
  /* font-family: fantasy; */
  font-size: small;
  font-weight: bold;
  font-style: normal;
  /* color: darkslategray; */
}

.logohover:hover {
  background-color: transparent !important;
  color: white;

  /* padding-top: 1px;
  padding-right: 1px;
  padding-left: 1px;
  padding-bottom: 1px; */
}

.menumobilebutton {
  background-color: transparent !important;
  color: white;
}
.menumobile {
  background-color: transparent !important;
  /* background-color: black !important; */
  color: white;
}

.mysplitbutton {
  /* background-color: lightblue;
  color: darkblue; */
  padding: 2px;
  font-size: 20px !important;
  border: none;
  cursor: pointer;
  min-width: 100%;
  /* text-align: left; */
  text-align: center;
  width: 180pt;
}
.mysplitbuttonmobile {
  background-color: lightblue;
  color: darkblue;
  padding: 1px;
  font-size: 8px !important;
  border: none;
  cursor: pointer;
  min-width: 100%;
  /* text-align: left; */
  text-align: center;
  width: 125pt;
}

.badgeright {
  text-align: right;
  align-items: end;
}

.imgcenter {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
}
.card {
  transition: 0.5s;
}
.card:hover {
  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */
  box-shadow: 0 4px 25px -6px rgb(0 0 0 / 18%);
}

#tv {
  position: relative;
  width: 200px;
  height: 150px;
  margin: 20px 0;
  background: red;
  border-radius: 50% / 10%;
  color: white;
  text-align: center;
  text-indent: 0.1em;
}
#tv:before {
  content: "";
  position: absolute;
  top: 10%;
  bottom: 10%;
  right: -5%;
  left: -5%;
  background: inherit;
  border-radius: 5% / 50%;
}

.buttonwithshadow:hover {
  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */
  box-shadow: 0 4px 16px 0 rgba(0, 0, 255, 0.3);
  font-weight: bolder;
}

.cardwithshadow {
  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */
  box-shadow: 0 4px 16px 0 rgba(0, 0, 255, 0.3);
}

.card-img-top {
  /* width: 100%;
  height: 140px; */
  object-fit: contain;
}
.card-img-Mobile {
  width: 100%;
  height: 120px;
  object-fit: contain;
}
.cardbodywidth {
  width: 100%;
}

.cardprodimg-on-cartview {
  width: 100%;
  height: 60px;
  object-fit: contain;
}
.PrdImageOnCartViewMobile {
  width: 70%;
  height: 60px;
  object-fit: contain;
}

.prd-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.carouselproductimgmobile {
  width: 100%;
  height: 350px;
  object-fit: contain;
}

.carouselimg {
  width: 100%;
  height: 10cm;
  /* object-fit: contain; */
}
.carousel-imgmobile {
  width: 100%;
  /* height: 150px; */
  /* object-fit: contain; */
}

.storenamebackgroundmobile {
  background-color: #20143c;
}
.storenamebackgroundmobile.active {
  color: white;
  background-color: #20143c;
}

.producttitlefontandsize {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 12px !important;
  color: black;
}

.producttitlefontandsizeDesktop {
  /* color: black; */
  /* font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif; */
  /* font-size: 20px !important; */
  /* text-transform: uppercase; */
}

.producttitlefontandsizeMobile {
  color: black;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 16px !important;
  text-transform: uppercase;
}

.cartviewtable {
  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */
  font-size: 14px !important;
}

.cartviewtableOnCheckout {
  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */
  font-size: 12px !important;
}

.incdectable {
  /* margin: auto; */
  width: 100% !important;
  padding: 0px;
}

.signupbutton {
  display: flex;
  align-items: center;
  justify-content: center;
}
.searchboxchanges {
  margin: auto;
  width: 80% !important;
  padding: 0px;
  font-size: 18px;
  height: 30px;
  border-radius: 0%;
  /* border-bottom: white;
  border-left: white;
  border-right: white;
  border-bottom: white; */
  text-align: left;
  padding-top: 12px; /*This needs to be modified to fit */
}

.searchboxconoffcanvas {
  margin: auto;
  width: 100% !important;
  padding: 0px;
  font-size: 18px;
  height: 30px;
  border-radius: 0%;
  /* border-bottom: white;
  border-left: white;
  border-right: white;
  border-bottom: white; */
  text-align: left;
  padding-top: 12px; /*This needs to be modified to fit */
}

.searchboxIconbutton {
  border-radius: 0%;
  border-bottom: white;
  border-left: white;
  border-right: white;
  border-bottom: white;
}

div.noPadding {
  padding-left: 0;
  padding-right: 0;
}

div.noMargin {
  margin-left: 0;
  margin-right: 0;
}
div.fullwidth {
  width: 100%;
}
table.fullwidth {
  width: 100%;
}

nav1 a:hover {
  /* border-top: 4px solid white;
  border-bottom: 4px solid white; */
  background: black;

  padding: 6px 0;
}

.navBarLink {
  margin: 3px;
}

.panel-body {
  height: 430px;
  width: 100%;
  /* overflow: hidden; */
  /* transform: rotate(90deg); */
  /* transform-origin: 188px 241px 0; */
}
.t1 {
  max-height: 390px;
  /* overflow: scroll; */
}
.t2 {
  height: 320px;
  width: 720px;
}

.testimonial-group > .row {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
.testimonial-group > .row > .col-4 {
  display: inline-block;
}
.col-4 {
  color: blue;
  font-size: 14px;
  padding-bottom: 20px;
  padding-top: 18px;
  padding-top: 18px;
  width: 220px;
}
.modernbgcolorgreen {
  background-color: #cff1ef;
}

.accordion-button:not(.collapsed) {
  /*color: #ffffff;
   background-color: #29008a; */
  /* color: #ffffff;
  background-color: deepskyblue; */
  color: #282c34;
  background-color: white;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

.table100width {
  width: 100%;
}

.removemarginpadding {
  margin: 0;
  padding: 0;
}

.whitespacewrap {
  white-space: nowrap;
}

.logocustom {
  color: yellow;
  /* background-color: ; */
  /* border: #29008a;
  border-color: #29008a; */
  /* border-bottom: 1px solid lightslategray;
  border-top: 1px solid #61dafb;
  border-left: 1px solid #61dafb;
  border-right: 1px solid #61dafb; */

  margin: 3px;
}
.wishlistbutton {
  border-color: pink;
  color: pink;
  background-color: white;
  border: 3px solid white;
  border-bottom: -3px solid white;
  border-top: -3px solid white;
  border-left: -3px solid white;
  border-right: -3px solid white;
}

.cartcustom {
  color: yellow;
  /* background-color: ; */
  /* border: #29008a;
  border-color: #29008a; */
  /* border-bottom: 1px solid lightslategray;
  border-top: 1px solid #61dafb;
  border-left: 1px solid #61dafb;
  border-right: 1px solid #61dafb; */

  margin: 3px;
}
.tablenopadding {
  padding: 0 !important;
}
.cartcustom:hover {
  color: black !important;
  border: white;
  background-color: white;
}

.accordionheadertitle {
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 26px;
}

.offcanvas-top.h-auto {
  bottom: initial;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.completeorderbtn {
  background-color: yellow;
}
.completeorderbtn:hover {
  background-color: yellowgreen;
}

.costfont {
  font-family: Arial, Helvetica, sans-serif;
  /* font-size: 16px !important; */
  /* color: black; */
}

.productNamewrap {
  overflow-wrap: break-word;
  white-space: normal;
}

.paymentcontainercustom {
  background-color: white;
  border: 1px solid burlywood;
  /* font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif,
    "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif; */
}

/* .MobileApp {
  color: #228b22;
  text-align: center;
} */
/* .footer {
  background-color: black;
  position: fixed;
  width: 100%;
  bottom: 0;
  color: white;
  font-size: 24px;
  margin-top: 0%;
  padding-top: 0%;
  padding-bottom: 0px;
} */

/* .footer {
  margin-top: 1rem;
  padding: 1rem;
  background-color: rgb(235, 195, 64);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
} */

/* .footer {
  background-color: green;
  border-top: 2px solid red;
  position: fixed;
  width: 100%;
  bottom: 0;
  color: white;
  font-size: 25px;
} */
.content-container {
  min-height: calc(0vh - 34px);
}
.footer--pin {
  position: fixed;
  background-color: black;
  border-top: 5px solid red;
  color: red;

  left: 0;
  bottom: 0;
  width: 100%;
  margin-top: 0%;
  padding-top: 0px;
  padding-bottom: 15px;
  font-size: 10px;
}

.orderpage2background {
  background-color: gainsboro;
}
.orderpage2backgroundMobile {
  background-color: aliceblue;
}
.checkoutform {
  background-color: whitesmoke;
  /* border: 2px solid black; */
}

/* .homebackground {
  background-color: #5c9cdc;
  color: black;  
  font-size: 14px;
} */
.mainnavbarborder {
  padding-bottom: 0%;
  border-bottom: 5px solid #20143c;
}
.mainnavbarlight {
  padding-bottom: 0%;
  border-bottom: 1px inset lightgrey;
}
/* .storetitle {
  color: #20143c;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
} */
/* .subnavbarcolor {
  background-color: #20143c;
  color: black;  
  font-size: 14px;
} */
.addtocartbutton {
  background-color: #20143c;
  color: white;
  font-size: 14px;
}
.viewallbutton {
  background-color: #20143c;
  color: white;
  font-size: 16px;
  font-weight: bold;
  text-align: right;
  margin-right: 1em;
  justify-content: end;
}

.primarythemecolor {
  background-color: #20143c;
}

.mainbackground {
  /* background-color: cornsilk; */
  /* background-color: aliceblue; */
  background-color: white;
}

.cartviewbarcolor {
  background-color: #f5f5f5;
  color: black;
  /* background-color: #29008a; */
  font-size: 14px;
}

.space_lg {
  width: 200px;
}

.mrpfontsize {
  font-size: 22px;
}

.card-round {
  border-radius: 15px 15px 15px 15px;
  padding-left: 10px;
  padding-right: 10px;
}

.cardimage-round {
  border-radius: 20px 20px 20px 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.TopCornerRounded {
  border-radius: 30px 30px 0px 00px;
  padding-left: 1px;
  padding-right: 1px;
}
.TopCornerRoundedSmall {
  border-radius: 10px 10px 0px 00px;
  padding-left: 1px;
  padding-right: 1px;
}

.CornersHalfRounded {
  border-radius: 30px 0px 30px 0px;
  padding-left: 1px;
  padding-right: 1px;
}

.leftCornersHalfRounded {
  border-radius: 50px 50px 50px 0px;
  padding-left: 1px;
  padding-right: 1px;
}

.CornersRounded {
  border-radius: 30px 30px 30px 30px;
  padding-left: 1px;
  padding-right: 1px;
}

.CornersRoundedSmall-v1 {
  border-radius: 10px 10px 10px 10px;
  padding-left: 1px;
  padding-right: 1px;
}
.CornersRoundedBig {
  border-radius: 50px 50px 50px 50px;
  padding-left: 1px;
  padding-right: 1px;
}

.ProductCardRounded {
  border-radius: 50px 50px 50px 50px;
  padding-left: 1px;
  padding-right: 1px;
}
.ProductImageTopRounded {
  border-radius: 15px 15px 0px 00px;
  padding-left: 0px;
  padding-right: 0px;
}

.CornersRoundedMenu {
  /* margin: 10px;
  border-radius: 130px 130px 130px 130px;
  margin-left: 100px;
  margin-right: 100px;
  position: relative;
  margin-top: 0px;
  z-index: 950; */
}
.carouselalign {
  /* position: relative;
  margin-top: -120px;
  z-index: 900; */
}
.bannervideo {
  position: relative;
  margin-top: -120px;
  z-index: 900;
}
.bannervideomobile {
  position: relative;
  margin-top: 0px;
  z-index: 900;
}

.buttonRounded {
  border-radius: 20px 20px 20px 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.buttonRoundedSmall {
  border-radius: 5px 5px 5px 5px;
  padding-left: 20px;
  padding-right: 20px;
}

.card-right {
  border-radius: 0 30px 30px 0;
}

.productmodal-body {
  max-height: 80vh;
  overflow-y: auto;
}

.categorydiv {
  margin: 1px, 1px;
  padding: 1px;
  background-color: green;
  width: 100%;
  height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;
}

.item {
  position: relative;
  padding-top: 10px;
  display: inline-block;
}
.notify-badge-left {
  position: absolute;
  left: 0px;
  /* right: -20px; */
  top: 10px;
  background: gray;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: white;
  padding: 5px 10px;
  font-size: 10px;
}

.notify-badge-right {
  position: absolute;
  right: 5px;
  top: 15px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}
.notify-badge-right_share {
  position: absolute;
  right: 15px;
  top: 15px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}
.notify-maincategory-badge-right_share {
  position: absolute;
  right: 45px;
  top: 25px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}
.notify-subcategory-badge-right_share {
  position: absolute;
  right: 5px;
  top: 15px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}
.notify-maincategory-mobile-badge-right_share {
  position: absolute;
  right: 10px;
  top: 20px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}
.notify-subcategory-mobile-badge-right_share {
  position: absolute;
  right: 0px;
  top: 0px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}

.notify-badge-right-mobile-wishlist {
  position: absolute;
  right: 10px;
  top: 10px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 5px;
  font-size: 10px;
}

.notify-badge-wishlist {
  position: relative;
  right: 4px;
  top: -16px;

  text-align: center;
  border-radius: 30px 30px 30px 30px;

  padding: 5px 8px;
  font-size: 10px;
}

.notify-badge-quote-wishlist {
  position: relative;
  right: -5px;
  top: -10px;

  text-align: center;
  border-radius: 30px 30px 30px 30px;

  padding: 5px 8px;
  font-size: 10px;
}
.notify-badge-cart {
  position: relative;
  right: 5px;
  top: -15px;

  text-align: center;
  border-radius: 30px 30px 30px 30px;

  padding: 5px 8px;
  font-size: 10px;
  width: 25px;
  height: 25px;
  display: inline-block;
}

.notify-badge-wishlist-mobile {
  /* position: absolute;
  right: 35px;
  top: 10px; */

  position: relative;
  right: 5px;
  top: -17px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: blue;
  padding: 6px 8px;
  font-size: 10px;
}
.notify-badge-cart-mobile {
  position: relative;
  top: -18px;
  right: 10px;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  padding: 5px 8px;
  font-size: 10px;
}
.notify-badge-wishlist-OnSinglePageView-mobile {
  position: absolute;
  /* left: 50px; */
  right: 20px;
  top: 10px;
  /* background: gray; */
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: white;
  padding: 10px 10px;
  font-size: 10px;
  /* position: relative;
  right: -35px;
  top: 0px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: blue;
  padding: 5px 8px;
  font-size: 8px; */
}

.react__slick__slider__parent {
  position: relative;
  /* place-items: center; */
  margin: auto;
  left: auto;
}

.slick-slide img {
  margin: auto;
  left: auto;
}
p.img-slide-text {
  margin: 2rem auto 0;
}

.react__slick__slider__parent .slick-prev,
.react__slick__slider__parent .slick-next {
  /* position: absolute; */
  position: absolute;
  top: 50%;
}
.react__slick__slider__parent .slick-prev {
  border-radius: 50%;
  color: black;
  z-index: 1;
}
.react__slick__slider__parent .slick-next {
  border-radius: 50%;
  color: black;
  z-index: 1;
}
.react__slick__slider__parent .slick-prev::before {
  color: black;
}
.react__slick__slider__parent .slick-next::before {
  color: black;
}

.react__slick__slider__parent1 {
  position: relative;
}

/* .react__slick__slider__parent1 .slick-prev,
.react__slick__slider__parent1 .slick-next {
  position: absolute;
  color: black;
  top: 40%;
} */
.react__slick__slider__parent1 .slick-prev {
  border-radius: 50%;
  color: black;
  background-color: #008f2f;
  z-index: 1;
}

.react__slick__slider__parent1 .slick-next {
  border-radius: 50%;
  color: black;
  z-index: 1;
}
.react__slick__slider__parent1 .slick-prev::before {
  color: black;
}
.react__slick__slider__parent1 .slick-next::before {
  color: black;
}

.slick-prev {
  left: -2% !important;
  z-index: 1;
}
.slick-next {
  right: -2% !important;
  z-index: 1;
}

.invertimage {
  filter: invert(100%);
}

.homefooter {
  background-color: #282c34;

  /* min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin); */
  color: white;
}

.signupmobilenoandotp {
  font-size: 18px;
}

.xxlmodal {
  width: 90vw; /* Occupy the 90% of the screen width */
  max-width: 90vw;
}

.whats-app {
  position: fixed;
  width: 50px;
  height: 50px;
  bottom: 60px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 3px 4px 15px 0px #00000052;
  /* left: 15px; */
  right: 15px;
  z-index: 100;
  padding: 3px;
}
.shop-now {
  position: fixed;
  /* margin: 0; */
  /* position: absolute; */
  top: 50%;
  /* width: 150px;
  height: 50px; */
  /* bottom: 140px; */
  /* background-color: #25d366; */
  color: #fff;
  /* border-radius: 50px; */
  text-align: center;
  font-size: 30px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  /* box-shadow: 3px 4px 3px #999; */
  /* left: 15px; */
  /* right: 15px; */
  right: 2%;
  z-index: 100;
  /* padding: 3px; */
}
.shop-now-mobile {
  position: fixed;
  /* margin: 0; */
  /* position: absolute; */
  top: 50%;
  /* width: 150px;
  height: 50px; */
  /* bottom: 140px; */
  /* background-color: #25d366; */
  color: #fff;
  /* border-radius: 50px; */
  text-align: center;
  font-size: 30px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  /* box-shadow: 3px 4px 3px #999; */
  /* left: 15px; */
  /* right: 15px; */
  right: 2%;
  z-index: 100;
  /* padding: 3px; */
}

.my-float {
  margin-top: 10px;
}
.zoom {
  /* padding: 50px;
  background-color: green;
  transition: transform 0.2s; 
  width: 200px;
  height: 200px;
  margin: 0 auto; */
  width: "100%";
  /* height: 300px; */
  overflow: auto;
  margin: 0 auto;
}

.zoom img {
  width: 100%;
  transition: 0.5s all ease-in-out;
}
.zoom:hover {
  transform: scale(
    1.1
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.img-hover-mover:hover {
  animation: mover 2s infinite alternate;
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}

.img-hover-zoom {
  /* height: 300px; [1.1] Set it as per your need */
  overflow: hidden; /* [1.2] Hide the overflowing of child elements */
}

/* [2] Transition property for smooth transformation of images */
.img-hover-zoom img {
  transition: transform 0.5s ease;
}

.img-hover-zoom video {
  transition: transform 0.5s ease;
}

/* [3] Finally, transforming the image when container gets hovered */
.img-hover-zoom:hover img {
  transform: scale(1.2);
}
.img-hover-zoom:hover video {
  transform: scale(1.2);
}

.image-blurred-edge {
  /* width: 200px;
  height: 200px; */
  /* you need to match the shadow color to your background or image border for the desired effect*/
  /* box-shadow: 0 0 8px 8px white inset; */
  /* filter: blur(5px); */
  width: 100%;
  /* position: absolute; */
  /* bottom: 0px;
  top: 0px; */
  box-shadow: inset -10px -10px 10px 20px white;
}

.spinnermodal-backdrop {
  -webkit-backdrop-filter: blur(0px);
          backdrop-filter: blur(0px);
  /* filter: blur(0px); */
  -webkit-filter: blur(0px);
  background-color: #01223770;
  /* background-color: orange; */
}
.spinnermodal-backdrop.in {
  opacity: 100 !important;
}
.spinnermodalcenter {
  display: flex !important;
  width: 100% !important;
  pointer-events: none;
  justify-content: center;
  align-items: center;
}
.loadspinnermodalalign {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.adshover:hover {
  object-fit: "cover";
}

.slick-dots {
  margin-top: 55px;
  margin-left: -5px;
  margin-right: -5px;
  display: flex;
  justify-content: center;
  li {
    list-style: none;
    display: inline-block;
    max-width: 50px;
    max-height: 56px;
    margin: 5px;

    img {
      opacity: 0.5;
      width: 80%;
      height: auto;
    }

    &.slick-active {
      img {
        opacity: 1;
      }
    }
  }
}

.paymentmode {
  font-size: 16px;
  /* left: -100px; */
  font-size: 20px;
  letter-spacing: 5px;
  display: inline-block;
  transform: rotate(270deg);
  /* left: -170px; */
  /* top: calc(50% - 30px); */
  top: 200px;
  position: relative;
  /* top: 100px;
  position: absolute; */
  text-transform: uppercase;
}

.single-item a.btn-dgn-2 {
  color: #008f2f;
  font-size: 16px;
  text-decoration: none;
  position: relative;
  font-weight: 600;
  letter-spacing: 1px;
}
.single-item a {
  text-decoration: none;
  display: inline-block;
}
.single-item a.btn-dgn-2:before {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0%;
  height: 1px;
  background: #008f2f;
  left: 0;
  transition: 0.5s;
}

.single-item a.btn-dgn-2:after {
  content: "\\f105";
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  right: -5px;
  transition: 0.5s;
}

.single-item a.btn-dgn-2:hover:after {
  right: -2px;
}

.single-item a.btn-dgn-2:hover:before {
  width: 100%;
}

.video-container {
  position: relative;
  padding-bottom: calc(var(--aspect-ratio, 0.5625) * 100%);
  height: 0;
  width: 100%;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1000px;
}

.slick-slide.slick-center img {
  /* transform: scale(1.2); */
  background-color: yellow;
}
.slick-slide.slick-center Table {
  /* background-color: yellow; */
  /* font-weight: bold;
  font-size: larger; */
}

.count-grp {
  padding: 25px 50px;
  /* background-color: #fff; */
  border-radius: 15px;
  box-shadow: 2px 3px 12px -9px #000000ad;
}
.count-grp h3 {
  font-size: 45px;
}
.count-grp h5 {
  font-size: 17px;
  letter-spacing: 1.5px;
}

.count-grp-mobile {
  padding: 5px 5px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 2px 3px 12px -9px #000000ad;
}
.count-grp-mobile h3 {
  font-size: 30px;
}
.count-grp-mobile h5 {
  font-size: 12px;
  letter-spacing: 1.5px;
}

.scroll-without-scrollbar {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  overflow-x: scroll;
}

.scroll-without-scrollbar::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.visitorscount {
  position: relative;
  top: 0px;

  /* padding: 5px 8px; */
  font-size: 12px;
}

.thumbnaillist-group {
  /* max-height: 550px;
  margin-bottom: 10px; */
  /* overflow: scroll; */
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.base-class {
  background-color: white;
  border: 1;
  border-color: lightgray;
}
.active-color {
  background-color: white;
  border: 1;
  border-color: black;
}

.hover-underline-animation {
  display: inline-block;
  position: relative;
  color: #0087ca;
}

.hover-underline-animation::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #0087ca;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.hover-underline-animation:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

/* @media only screen and (max-width: 2000px) { */
.ectittle-black-outline-5 {
  font-family: "Raleway Black";
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #30303050;
  font-size: 60px;
  color: transparent;
  display: inline-block;
  transform: rotate(0deg);
  left: 350px;
  /* left: -156px; */
  /* top: 350px; */
  /* top: calc(50% - 50px); */
  position: absolute;
  text-transform: uppercase;
}
.ectittle-black-outline-kiosk {
  font-family: "Raleway Black";
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #30303050;
  font-size: 120px;
  color: transparent;
  display: inline-block;
  /* transform: rotate(0deg); */
  /* left: 350px; */
  text-align: center;
  /* left: -156px; */
  /* top: 350px; */
  /* top: calc(50% - 50px); */
  /* position: absolute; */
  text-align: center;
  text-transform: uppercase;
}
/* } */

@media only screen and (max-width: 1366px) {
  .ectittle-black-outline-5 {
    font-family: "Raleway Black";
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #30303050;
    font-size: 60px;
    color: transparent;
    display: inline-block;
    transform: rotate(0deg);
    left: 200px;
    /* left: -156px; */
    /* top: 350px; */
    /* top: calc(50% - 50px); */
    position: absolute;
    text-transform: uppercase;
  }
}

.ectittle-black-outline-mobile {
  font-family: "Raleway Black";
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #30303050;
  font-size: 60px;
  color: transparent;
  display: inline-block;
  transform: rotate(0deg);
  left: 30px;
  /* left: -156px; */
  /* top: 350px; */
  /* top: calc(50% - 50px); */
  position: absolute;
  text-transform: uppercase;
}

.bankreceiptheight {
  margin: 1px, 1px;
  padding: 1px;
  /* background-color: green; */
  width: 100%;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;
}

.verticalaligncenterstart {
  /* vertical-align: middle; */
  display: flex;
  vertical-align: middle;
  align-items: start;
  justify-content: start;
  z-index: 9999;
}

.btn-green-2 {
  /* background: #008f2f; */
  background-image: linear-gradient(to right, #008f2f, #04cd46);
  background-color: #4ad168;
  border: 1px solid #008f2f;
  padding: 7px;
  color: #fff;
  width: 125px;
  letter-spacing: 0.5px;
  font-size: 14px;
  transition: 0.5s;
}
.btn-green-2:hover {
  /* background: #007a28; */
  color: #fff;
  box-shadow: 0 26px 25px -19px #00000063;
  border-radius: 10px;
}

.inputboxunderline {
  width: 100%;
  padding: 2px 2px;
  margin: 2px 0;
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid lightgray;
}

.image-container-for-button {
  position: relative;
  width: 100%;
}
.image-container-for-button video {
  width: 100%;
  height: auto;
}

.image-container-for-button .btn1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
}

.image-container-for-button .btn1:hover {
  background-color: black;
}

/* CheckOut Page 12-3-2024 */
div.checkout-container {
  max-width: 1780px;
  margin: 0 auto !important;
  position: relative;
  margin-bottom: 100px !important;
}
.checkout-container .inner-row {
  padding-left: 130px !important;
}
.checkout-container .ectittle-black-outline-5 {
  transform: rotate(270deg);
  left: -200px;
  top: 300px;
  font-size: 98px;
}
.checkout-container .hstack h5 {
  margin-bottom: 0px;
}
.checkout-container .checkout-lef-col .form-control,
.checkout-container .checkout-lef-col .form-select {
  border: 0px;
  border-bottom: 1px solid #757575;
  border-radius: 0px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  height: calc(4.3rem + 2px) !important;
  padding-top: 2.5rem !important;
}
.checkout-container .form-floating label {
  padding-left: 0px !important;
  padding-right: 0px !important;
  font-size: 18px;
  color: #999999;
}
.checkout-container .form-check-label h5 {
  margin-bottom: 0px;
  font-size: 18px;
}
.form-check-control .form-check {
  margin-bottom: 0px !important;
}

.bank-statement-section .bankreceiptheight {
  padding: 15px 15px 0;
  height: 290px;
}
.bank-statement-section .bankreceiptheight h2 {
  font-size: 16px;
  font-family: "Raleway SemiBold";
}
.bank-statement-section .bankreceiptheight th,
.bank-statement-section .bankreceiptheight td {
  font-size: 15px;
  vertical-align: top;
  min-width: 185px;
  font-weight: 400;
  padding-bottom: 15px;
}
.bank-statement-section .bankreceiptheight td {
  color: #000000;
}
.delivery-note,
.delivery-note + span {
  font-size: 11px;
}
.delivery-note::before {
  content: "*";
  font-size: 27px;
  color: #f1587b;
  line-height: 1;
  vertical-align: top;
  display: inline-block;
  margin-right: 4px;
  position: relative;
  top: 4px;
  margin-left: -8px;
}
.delivery-note b {
  font-weight: normal;
}
.bank-statement-section .bankreceiptheight i {
  font-style: normal;
  font-size: 15px;
  color: #000000;
  background-color: #e9f8ee;
  display: block;
  padding: 0 15px 15px;
  margin: 20px -15px 0;
}
.bank-statement-section .bankreceiptheight i b {
  font-weight: normal;
}
.bank-statement-section .bankreceiptheight i b u {
  color: #3c4242;
  text-decoration: none;
}
.checkout-container button.btn-green-2 {
  background: linear-gradient(30deg, #36dd68 0%, #dddf78 100%);
  border: 0px;
  font-size: 16px;
  font-family: "Raleway Bold";
  width: auto;
  padding: 10px 26px;
}
.checkout-right {
  padding-top: 80px;
}
.checkout-right h4 {
  font-size: 20px;
  color: #303030;
  margin-bottom: 20px;
}
.checkout-right h4 .item-count {
  font-size: 14px;
  width: 20px;
  height: 20px;
  color: #fff;
  border-radius: 50%;
  background-color: #db4437;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -3px;
  left: 5px;
}
.checkout-right .table-responsive-md {
  border-top: 1px solid #e5e4e4;
  margin-top: 5px;
  padding-top: 15px;
}
.checkout-right .table-responsive-md .table > :not(:first-child) {
  border-top: 0px;
}
.checkout-right .table-responsive-md th {
  font-size: 15px;
  font-family: "Raleway Bold";
  /*text-align: left;*/
}
.checkout-right .table-responsive-md td {
  font-size: 16px;
}
.checkout-right .table-responsive-md td.col-md-1 {
  padding-top: 0px;
}
.checkout-right .table-responsive-md .table > :not(caption) > * > * {
  border: 0px;
}
.checkout-right .table-responsive-md td button.rounded-circle {
  outline: 0px !important;
  box-shadow: none;
}
.incdectable input {
  width: 59px;
  /* background: transparent !important; */
  margin: 0 6px;
}
.delivery-method .form-check {
  margin-bottom: 0px;
}
.delivery-method .form-check input {
  position: relative;
  opacity: 0;
}
.delivery-method .form-check label {
  position: relative;
}
.delivery-method .form-check label:before {
  width: 17px;
  height: 17px;
  content: "";
  border-radius: 50%;
  border: 2px solid #dcdcdc;
  position: absolute;
  left: -23px;
  top: 3px;
}
.delivery-method .form-check label:after {
  width: 9px;
  height: 9px;
  content: "";
  border-radius: 50%;
  background-color: #23b14d;
  position: absolute;
  left: -19px;
  top: 7px;
  opacity: 0;
  transition: all 0.4s ease;
  transform: scale(0);
}
.delivery-method .form-check input:checked + label:before {
  border-color: #23b14d;
}
.delivery-method .form-check input:checked + label:after {
  opacity: 1;
  transform: scale(1);
}
.order-summary h4 {
  border-bottom: 1px solid #e5e4e4;
  padding-bottom: 18px;
  margin-bottom: 5px;
}
.order-details {
  font-size: 16px;
  color: #303030;
}
.order-details .row {
  margin-bottom: 10px;
}
.order-details .text-end {
  color: #000000;
  font-family: "Raleway SemiBold";
}
.order-details hr {
  background-color: #e5e4e4;
  opacity: 1;
}
.total-text h3 {
  color: #595757;
  font-family: "Raleway SemiBold";
}
.coupon-code-text {
  color: #303030;
  font-family: "Raleway SemiBold";
}
.coupon-code-text .hstack {
  padding-left: 0px;
  margin-top: 10px;
}
.coupon-code-text .hstack input {
  margin-left: 0px !important;
  border: 0px;
  border-bottom: 1px solid #757575;
  border-radius: 0px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  height: 39px !important;
  background-color: transparent !important;
  text-align: left;
  font-size: 13px;
}
.coupon-code-text .hstack input::placeholder {
  color: #999999;
  opacity: 1;
}
.coupon-code-text .hstack input::-webkit-input-placeholder {
  color: #999999;
  opacity: 1;
}
.coupon-code-text .hstack button {
  background: linear-gradient(30deg, #36dd68 0%, #dddf78 100%);
  border: 0px;
  font-size: 16px;
  font-family: "Raleway Bold";
  width: auto;
  padding: 8px 26px;
}
.note-text {
  color: #333333;
  font-size: 11px;
  letter-spacing: 0.09px;
  margin-top: 30px !important;
}
.note-text:before {
  content: "*";
  font-size: 27px;
  color: #f1587b;
  line-height: 1;
  vertical-align: top;
  display: inline-block;
  margin-right: 4px;
  position: relative;
  top: 0px;
  margin-left: -8px;
}
.note-text:empty:before {
  display: none;
}
.billing-address .bg-light {
  padding: 15px !important;
}
.billing-address .bg-light h6 {
  margin-bottom: 0px !important;
}
.billing-address .bg-light h6 label {
  font-size: 18px;
}
.billing-address input[type="radio"] {
  position: relative;
  opacity: 0;
}
.billing-address label {
  position: relative;
}
.billing-address input[type="radio"] + label:before {
  width: 17px;
  height: 17px;
  content: "";
  border-radius: 50%;
  border: 2px solid #dcdcdc;
  position: absolute;
  left: -23px;
  top: 3px;
}
.billing-address input[type="radio"] + label:after {
  width: 9px;
  height: 9px;
  content: "";
  border-radius: 50%;
  background-color: #23b14d;
  position: absolute;
  left: -19px;
  top: 7px;
  opacity: 0;
  transition: all 0.4s ease;
  transform: scale(0);
}
.bank-statement-section input[type="radio"] + label:before {
  top: 2px;
}
.bank-statement-section input[type="radio"] + label:after {
  top: 6px;
}
.billing-address input[type="radio"]:checked + label:before {
  border-color: #23b14d;
}
.billing-address input[type="radio"]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}
.billing-detail {
  font-size: 16.5px;
  line-height: 1.5;
  color: #000000;
}
.payment-mode {
  font-size: 17px;
  font-family: "Raleway SemiBold";
}
.cartviewtableOnCheckout tbody > tr > td {
  padding-bottom: 20px;
}
/* Common Changes */
/* .offcanvas-header .offcanvas-title {
  color: rgb(35, 177, 77);
} */
.card h2 {
  font-size: 19px !important;
  padding: 0 5px;
}
.thumbnaillist-group .base-class {
  background-color: #ebebeb;
}
.active-color.list-group-item {
  border-color: rgb(35, 177, 77);
  border-width: 2px;
}
.slider_white_bg.carousel-caption {
  background-color: rgba(255, 255, 255, 0.5) !important;
  opacity: 1 !important;
}
.content_part h1 {
  line-height: 1.2 !important;
}
body .text-success {
  color: rgb(35, 177, 77) !important;
}
.single-item a.btn-dgn-2 {
  color: rgb(35, 177, 77) !important;
}
.btn-primary.btn-green {
  border-width: 0px;
}
.thumbnaillist-group {
  overflow-x: auto !important;
}
/* .navbar-collapse svg {
  color: rgb(35, 177, 77) !important;
} */
.offcanvas-body .searchboxconoffcanvas {
  border: none;
  border-bottom: 1px solid #757575;
  border-radius: 0px;
}
.search-wrap svg {
  max-width: 20px;
}
/* @media screen and (-webkit-min-device-pixel-ratio:0) {
  input[type='range'] {
    overflow: hidden;
    width: 80px;
    -webkit-appearance: none;
    background-color: #9a905d;
  }
  
  input[type='range']::-webkit-slider-runnable-track {
    height: 10px;
    -webkit-appearance: none;
    color: #13bba4;
    margin-top: -1px;
  }
 

} */

input[type="range"]::-webkit-slider-runnable-track {
  background: #b8e3c5 !important;
  height: 7px !important;
}
input[type="range"]::-webkit-slider-thumb { /* Override default look */
  appearance: none;
  background-color: #23b14d !important;
}
/** FF*/
input[type="range"]::-moz-range-progress {
  background-color: #b8e3c5 !important;
}
input[type="range"]::-moz-range-track {
  background-color: #9a905d;
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: #b8e3c5;
}
input[type="range"]::-ms-fill-upper {
  background-color: #9a905d;
}

.UserProfileDsn .form-floating label {
  padding: 0px !important;
}
.moveLabelUp label {
  top: -10px;
}
.moveLabelUp.form-floating > .form-control:not(:placeholder-shown) {
  padding-bottom: 0;
  padding-top: 5px;
}
/* Mobile Checkout*/
@media (max-width: 1101px) {
  .checkout-container-mob .inner-row-mob {
    padding: 0 30px;
  }
  .checkout-container-mob .checkout-mob-title {
    font-size: 18px;
  }
  .bg-light-grey {
    background-color: #f8f8f8;
  }
  .checkout-container-mob .delivery-method .form-check label {
    font-size: 18px;
    line-height: 1.2;
    color: rgb(35, 177, 77);
  }
  .checkout-container-mob .billing-address .lable-only .form-check label {
    font-size: 18px;
    line-height: 1.2;
    color: rgb(35, 177, 77);
  }
  .checkout-container-mob .checkout-lef-col .form-control,
  .checkout-container .checkout-lef-col .form-select {
    background-color: transparent;
  }
  .billing-address .form-check-control:empty {
    padding: 0px !important;
  }
}
@media (max-width: 767px) {
  .checkout-container .ectittle-black-outline-5 {
    transform: rotate(0deg);
    left: 19px;
    top: 0;
    font-size: 40px;
    position: absolute;
  }
  .checkout-container .inner-row {
    padding-left: 0px !important;
  }
  .billing-address .bg-light h6 label {
    font-size: 13px;
  }
  .billing-address input[type="radio"] + label:after {
    top: 4px;
  }
  .billing-address input[type="radio"] + label:before {
    top: 0px;
  }
  .checkout-container-mob .delivery-method .form-check label {
    font-size: 14px;
  }
  .checkout-container-mob .billing-address .lable-only .form-check label {
    font-size: 14px;
  }
  .bank-statement-section .bankreceiptheight th,
  .bank-statement-section .bankreceiptheight td {
    display: block;
    padding-bottom: 0px;
  }
  .bank-statement-section .bankreceiptheight td {
    padding-bottom: 20px;
  }
  .checkout-right.p-0 {
    padding: 10px 0px 0 !important;
  }
  .checkout-right .table-responsive-md td {
    font-size: 13px;
  }
  .coupon-code-text .hstack button {
    font-size: 14px;
    padding: 8px 41px;
    width: auto;
    min-width: inherit;
  }
  .bank-statement-section .bankreceiptheight i {
    font-size: 14px;
  }
  .bank-statement-section .bankreceiptheight th,
  .bank-statement-section .bankreceiptheight td {
    font-size: 14px;
  }
  .checkout-container .form-floating label {
    font-size: 15px;
  }
  .checkout-container-mob .ectittle-black-outline-mobile {
    font-size: 50px;
  }
  .delivery-method .form-check label:before {
    top: 0;
  }
  .delivery-method .form-check label:after {
    top: 4px;
  }
  .checkout-container .form-check-label h5 {
    font-size: 15px;
  }
  .cartviewtableOnCheckout input {
    margin: 0 5px;
  }
  .bank-statement-section .bankreceiptheight {
    height: auto;
  }
  .checkout-right .table-responsive-md th {
    font-size: 13px;
  }
  .order-details {
    font-size: 14px;
  }
}

.textonimagecentered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.textonimagebottom {
  position: absolute;
  left: 50%;
  bottom: 200px;
  transform: translate(-50%, -50%);
}
.textonimagebottommobile {
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translate(-50%, -50%);
}

.ribbonright {
  width: 60px;
  font-size: 14px;
  padding: 4px;
  position: absolute;
  right: -5px;
  top: 0px;
  text-align: center;
  border-radius: 25px;
  transform: rotate(20deg);
  background-color: #ff9800;
  color: white;
}

.ribboncorners {
  border-radius: 10px 0px 10px 0px;
  padding-left: 1px;
  padding-right: 1px;
}

.ribbonleft {
  width: 60px;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  /* left: -3px; */
  left: 0px;
  top: 0px;
  text-align: center;
  /* border-radius: 0px; */
  /* transform: rotate(-25deg); */
  /* background-color: darkred; */
  color: white;
}
.ribbonleftgreen {
  width: 60px;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  /* left: -15px; */
  left: 0px;
  top: 0px;
  text-align: center;
  /* border-radius: 0px; */
  /* transform: rotate(-25deg); */
  background-color: #23b14d;
  color: white;
}

.ribbon-1 {
  position: fixed;
  background: #08769b;
  box-shadow: 0 0 0 999px #08769b;
  clip-path: inset(0 -100%);
}
.left {
  inset: 0 auto auto 0;
  transform-origin: 100% 0;
  transform: translate(-29.3%) rotate(-45deg);
}
.right {
  inset: 0 0 auto auto;
  transform-origin: 0 0;
  transform: translate(29.3%) rotate(45deg);
}

.ribbonmodernright {
  --f: 10px; /* control the folded part*/
  --r: 15px; /* control the ribbon shape */
  --t: 60px; /* the top offset */

  position: absolute;
  inset: var(--t) calc(-1 * var(--f)) auto auto;
  padding: 0 10px var(--f) calc(10px + var(--r));
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - var(--f)),
    calc(100% - var(--f)) 100%,
    calc(100% - var(--f)) calc(100% - var(--f)),
    0 calc(100% - var(--f)),
    var(--r) calc(50% - var(--f) / 2)
  );
  /* background: orangered;
  color: #000000; */
  box-shadow: 0 calc(-1 * var(--f)) 0 inset #0005;
}

.addcarthide {
  display: none;
}

.cartDIV:hover + .addcarthide {
  display: block;
  /* color: red; */
}
.addtocartDIV:hover {
  display: block;
  /* color: red; */
}

.checkoutEditstyle {
  height: auto !important;
  padding-top: 0 !important;
  margin-top: 25px !important;
}

.glow-border {
  color: white;
  padding: 20px 40px;
  border: 3px solid #0ff;
  border-radius: 10px;
  animation: glow 2s infinite ease-in-out;
  text-align: center;
}

@keyframes glow {
  0%,
  100% {
    box-shadow: 0 0 5px #0ff, 0 0 10px #0ff, 0 0 20px #0ff;
  }
  50% {
    box-shadow: 0 0 10px #0ff, 0 0 20px #0ff, 0 0 30px #0ff;
  }
}

.animated-heading {
  display: inline-block;
  position: relative;
  font-size: 32px;
  color: #333;
  padding-bottom: 5px;
}

.animated-heading::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, #ff416c, #ff4b2b, #ff416c);
  background-size: 200% 100%;
  animation: border-slide 3s linear infinite;
}

@keyframes border-slide {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.modal-90w {
  max-width: 90% !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4CAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,4CAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB;yDAC6D;EAC7D,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,4CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B;yDAC8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4CAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,4CAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qFAAqF;EACrF,kCAAkC;AACpC;;AAEA;;GAEG;AACH;;GAEG;;AAEH;EACE,0CAA0C;AAC5C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,6FAA6F;AAC7F;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2HAA2H;AAC3H;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;GAGG;AACH;EACE,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,YAAY;;EAEZ;;;wBAGsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE;oBACkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE;kBACgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB;uCACqC;EACrC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gDAAgD;EAChD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB;;;yBAGuB;EACvB,gBAAgB;EAChB,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB;;;yBAGuB;EACvB,gBAAgB;EAChB,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE;mCACiC;EACjC,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;+BAC6B;EAC7B;kCACgC;EAChC,cAAc;EACd,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB;0BACwB;EACxB;;;oCAGkC;;EAElC,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB;0BACwB;EACxB;;;oCAGkC;;EAElC,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;;;GAGG;AACH;;;;;;;;;;GAUG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;GAQG;AACH;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;;EAEV,OAAO;EACP,SAAS;EACT,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;;GAIG;AACH;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;;;;GAIG;AACH;;;;GAIG;AACH;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;;;;;;iBAMe;AACjB;AACA;EACE;;iBAEe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;;EAEV,kBAAkB;EAClB,kCAAkC;;EAElC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;;EAEV,kBAAkB;EAClB,kCAAkC;;EAElC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;;EAEV,kBAAkB;EAClB,kCAAkC;;EAElC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;;cAEY;;EAEZ,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;;;;;;;mBAQiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;GAKG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;;EAEzB;;;;;kCAKgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,QAAQ;EACR;iBACe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wEAAwE;EACxE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,QAAQ;EACR;iBACe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wEAAwE;EACxE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;;;;;mBAKiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE;;GAEC,EAAE,qFAAqF;AAC1F;;AAEA;EAEE,sCAAsC;AACxC;AASA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iDAAiD;EACjD,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA,gEAAgE;AAChE;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;kBACgB;EAChB,gGAAgG;EAChG,yCAAyC;EACzC,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB;aACW;EACX,6CAA6C;AAC/C;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB;IACE,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;;IAEX;MACE,YAAY;MACZ,UAAU;MACV,YAAY;IACd;;IAEA;MACE;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB;uBACqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B;sBACoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB,EAAE,gCAAgC;EAC1D,qBAAqB,EAAE,gBAAgB;EACvC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;wBACsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,MAAM;;AAEN;EACE;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,oCAAoC;IACpC,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;EAC3B;AACF;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,4DAA4D;EAC5D,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,4DAA4D;EAC5D,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;AACA,mBAAmB;AACnB;;GAEG;AACH;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;;GAEG;AACH;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,4CAC4B,0BAA0B;EACpD,gBAAgB;EAChB,oCAAoC;AACtC;AACA,OAAO;AACP;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA,MAAM;AACN;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,MAAM;IACN,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,SAAS,EAAE,2BAA2B;EACtC,SAAS,EAAE,6BAA6B;EACxC,SAAS,EAAE,mBAAmB;;EAE9B,kBAAkB;EAClB,6CAA6C;EAC7C,8CAA8C;EAC9C;;;;;;;;GAQC;EACD;mBACiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE;;IAEE,sDAAsD;EACxD;EACA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@font-face {\r\n  font-family: \"Montserrat\";\r\n  src: url(/public/dist/fonts/Montserrat-Regular.ttf);\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Montserrat SemiBold\";\r\n  src: url(/public/dist/fonts/Montserrat-SemiBold.ttf);\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Montserrat Bold\";\r\n  src: url(/public/dist/fonts/Montserrat-Bold.ttf);\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Raleway\";\r\n  src: url(\"/public/dist/fonts/Raleway-Regular.woff\") format(\"woff\"),\r\n    url(\"/public/dist/fonts/Raleway-Regular.ttf\") format(\"ttf\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Raleway Bold\";\r\n  src: url(\"/public/dist/fonts/Raleway-Bold.ttf\");\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Raleway SemiBold\";\r\n  src: url(\"/public/dist/fonts/Raleway-SemiBold.woff\") format(\"woff\"),\r\n    url(\"/public/dist/fonts/Raleway-SemiBold.ttf\") format(\"ttf\");\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Raleway Black\";\r\n  src: url(\"/public/dist/fonts/Raleway-Black.ttf\");\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Raleway ExtraBold\";\r\n  src: url(\"/public/dist/fonts/Raleway-ExtraBold.ttf\");\r\n  font-display: swap;\r\n}\r\nbody {\r\n  font-family: \"Raleway\", sans-serif;\r\n  color: #202020;\r\n  font-size: 14px;\r\n  background-color: #f5f5f5;\r\n  /* it's required since after  razorpay window close, screen vertical scroll freeze  */\r\n  /* overflow: visible !important; */\r\n}\r\n\r\n/* body {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n} */\r\n/* body {\r\n  overflow: visible !important;\r\n} */\r\n\r\n.bold_font {\r\n  font-family: \"Montserrat Bold\", sans-serif;\r\n}\r\n.semibold_font {\r\n  /* font-family: \"Montserrat SemiBold\", sans-serif; */\r\n}\r\n.title-dsn h2 {\r\n  font-size: 50px;\r\n  margin-bottom: 15px;\r\n}\r\n.title-dsn h3 {\r\n  font-size: 35px;\r\n  line-height: 1.5;\r\n}\r\n.title-dsn h4 {\r\n  font-size: 28px;\r\n  line-height: 1.5;\r\n}\r\n.title-dsn h5 {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.title-dsn p {\r\n  font-size: 20px;\r\n  line-height: 1.5;\r\n  opacity: 0.6;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.confirmpaybutton {\r\n  background-color: yellow;\r\n  color: #282c34;\r\n  border-width: 10;\r\n  border-color: #29008a;\r\n  border: 2px solid black;\r\n  border-radius: 12px;\r\n}\r\n.carouselbottomborder {\r\n  border-width: 10;\r\n  /* border-color: #29008a; */\r\n  border: 2px solid white;\r\n  border-radius: 12px;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n/* Small devices (Phones, 600pxand down) -- this would display the text at 5.0rem on phones */\r\n@media only screen and (max-width: 600px) {\r\n  html {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* Large devices (laptops/desktops, 992px and up) -- This would display the text at 10.0rem on laptops and larger screens */\r\n@media only screen and (min-width: 992px) {\r\n  html {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* .navbar-brand {\r\n  color: green !important;\r\n  font-size: 1.5rem;\r\n} */\r\n.navbar-custom {\r\n  background-color: darkblue !important;\r\n  color: blue !important;\r\n  font-size: 1rem;\r\n}\r\n.navbar-topnav {\r\n  background-color: blueviolet;\r\n}\r\n\r\n.anyVerticalScroll {\r\n  height: 800px;\r\n  /* overflow-y: scroll; */\r\n}\r\n\r\n.verticalaligncentertd {\r\n  display: flex;\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.buttonhover:hover {\r\n  background-color: blue;\r\n  padding-top: 2px;\r\n  padding-right: 2px;\r\n  padding-left: 2px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.menuhover:hover {\r\n  /* background-color: transparent !important; */\r\n  background-color: black !important;\r\n  font-weight: bold;\r\n  text-underline-position: below;\r\n  color: white !important;\r\n}\r\n.menufont {\r\n  /* font-family: \"muli\"; */\r\n  /* font-family: fantasy; */\r\n  font-size: small;\r\n  font-weight: bold;\r\n  font-style: normal;\r\n  /* color: darkslategray; */\r\n}\r\n\r\n.logohover:hover {\r\n  background-color: transparent !important;\r\n  color: white;\r\n\r\n  /* padding-top: 1px;\r\n  padding-right: 1px;\r\n  padding-left: 1px;\r\n  padding-bottom: 1px; */\r\n}\r\n\r\n.menumobilebutton {\r\n  background-color: transparent !important;\r\n  color: white;\r\n}\r\n.menumobile {\r\n  background-color: transparent !important;\r\n  /* background-color: black !important; */\r\n  color: white;\r\n}\r\n\r\n.mysplitbutton {\r\n  /* background-color: lightblue;\r\n  color: darkblue; */\r\n  padding: 2px;\r\n  font-size: 20px !important;\r\n  border: none;\r\n  cursor: pointer;\r\n  min-width: 100%;\r\n  /* text-align: left; */\r\n  text-align: center;\r\n  width: 180pt;\r\n}\r\n.mysplitbuttonmobile {\r\n  background-color: lightblue;\r\n  color: darkblue;\r\n  padding: 1px;\r\n  font-size: 8px !important;\r\n  border: none;\r\n  cursor: pointer;\r\n  min-width: 100%;\r\n  /* text-align: left; */\r\n  text-align: center;\r\n  width: 125pt;\r\n}\r\n\r\n.badgeright {\r\n  text-align: right;\r\n  align-items: end;\r\n}\r\n\r\n.imgcenter {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  object-fit: contain;\r\n}\r\n.card {\r\n  transition: 0.5s;\r\n}\r\n.card:hover {\r\n  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */\r\n  box-shadow: 0 4px 25px -6px rgb(0 0 0 / 18%);\r\n}\r\n\r\n#tv {\r\n  position: relative;\r\n  width: 200px;\r\n  height: 150px;\r\n  margin: 20px 0;\r\n  background: red;\r\n  border-radius: 50% / 10%;\r\n  color: white;\r\n  text-align: center;\r\n  text-indent: 0.1em;\r\n}\r\n#tv:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 10%;\r\n  bottom: 10%;\r\n  right: -5%;\r\n  left: -5%;\r\n  background: inherit;\r\n  border-radius: 5% / 50%;\r\n}\r\n\r\n.buttonwithshadow:hover {\r\n  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */\r\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 255, 0.3);\r\n  font-weight: bolder;\r\n}\r\n\r\n.cardwithshadow {\r\n  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3); */\r\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 255, 0.3);\r\n}\r\n\r\n.card-img-top {\r\n  /* width: 100%;\r\n  height: 140px; */\r\n  object-fit: contain;\r\n}\r\n.card-img-Mobile {\r\n  width: 100%;\r\n  height: 120px;\r\n  object-fit: contain;\r\n}\r\n.cardbodywidth {\r\n  width: 100%;\r\n}\r\n\r\n.cardprodimg-on-cartview {\r\n  width: 100%;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n.PrdImageOnCartViewMobile {\r\n  width: 70%;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n\r\n.prd-img {\r\n  width: 50px;\r\n  height: 50px;\r\n  object-fit: contain;\r\n}\r\n.carouselproductimgmobile {\r\n  width: 100%;\r\n  height: 350px;\r\n  object-fit: contain;\r\n}\r\n\r\n.carouselimg {\r\n  width: 100%;\r\n  height: 10cm;\r\n  /* object-fit: contain; */\r\n}\r\n.carousel-imgmobile {\r\n  width: 100%;\r\n  /* height: 150px; */\r\n  /* object-fit: contain; */\r\n}\r\n\r\n.storenamebackgroundmobile {\r\n  background-color: #20143c;\r\n}\r\n.storenamebackgroundmobile.active {\r\n  color: white;\r\n  background-color: #20143c;\r\n}\r\n\r\n.producttitlefontandsize {\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  font-size: 12px !important;\r\n  color: black;\r\n}\r\n\r\n.producttitlefontandsizeDesktop {\r\n  /* color: black; */\r\n  /* font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\r\n    \"Lucida Sans\", Arial, sans-serif; */\r\n  /* font-size: 20px !important; */\r\n  /* text-transform: uppercase; */\r\n}\r\n\r\n.producttitlefontandsizeMobile {\r\n  color: black;\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  font-size: 16px !important;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cartviewtable {\r\n  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */\r\n  font-size: 14px !important;\r\n}\r\n\r\n.cartviewtableOnCheckout {\r\n  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */\r\n  font-size: 12px !important;\r\n}\r\n\r\n.incdectable {\r\n  /* margin: auto; */\r\n  width: 100% !important;\r\n  padding: 0px;\r\n}\r\n\r\n.signupbutton {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.searchboxchanges {\r\n  margin: auto;\r\n  width: 80% !important;\r\n  padding: 0px;\r\n  font-size: 18px;\r\n  height: 30px;\r\n  border-radius: 0%;\r\n  /* border-bottom: white;\r\n  border-left: white;\r\n  border-right: white;\r\n  border-bottom: white; */\r\n  text-align: left;\r\n  padding-top: 12px; /*This needs to be modified to fit */\r\n}\r\n\r\n.searchboxconoffcanvas {\r\n  margin: auto;\r\n  width: 100% !important;\r\n  padding: 0px;\r\n  font-size: 18px;\r\n  height: 30px;\r\n  border-radius: 0%;\r\n  /* border-bottom: white;\r\n  border-left: white;\r\n  border-right: white;\r\n  border-bottom: white; */\r\n  text-align: left;\r\n  padding-top: 12px; /*This needs to be modified to fit */\r\n}\r\n\r\n.searchboxIconbutton {\r\n  border-radius: 0%;\r\n  border-bottom: white;\r\n  border-left: white;\r\n  border-right: white;\r\n  border-bottom: white;\r\n}\r\n\r\ndiv.noPadding {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\ndiv.noMargin {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\ndiv.fullwidth {\r\n  width: 100%;\r\n}\r\ntable.fullwidth {\r\n  width: 100%;\r\n}\r\n\r\nnav1 a:hover {\r\n  /* border-top: 4px solid white;\r\n  border-bottom: 4px solid white; */\r\n  background: black;\r\n\r\n  padding: 6px 0;\r\n}\r\n\r\n.navBarLink {\r\n  margin: 3px;\r\n}\r\n\r\n.panel-body {\r\n  height: 430px;\r\n  width: 100%;\r\n  /* overflow: hidden; */\r\n  /* transform: rotate(90deg); */\r\n  /* transform-origin: 188px 241px 0; */\r\n}\r\n.t1 {\r\n  max-height: 390px;\r\n  /* overflow: scroll; */\r\n}\r\n.t2 {\r\n  height: 320px;\r\n  width: 720px;\r\n}\r\n\r\n.testimonial-group > .row {\r\n  display: block;\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n}\r\n.testimonial-group > .row > .col-4 {\r\n  display: inline-block;\r\n}\r\n.col-4 {\r\n  color: blue;\r\n  font-size: 14px;\r\n  padding-bottom: 20px;\r\n  padding-top: 18px;\r\n  padding-top: 18px;\r\n  width: 220px;\r\n}\r\n.modernbgcolorgreen {\r\n  background-color: #cff1ef;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  /*color: #ffffff;\r\n   background-color: #29008a; */\r\n  /* color: #ffffff;\r\n  background-color: deepskyblue; */\r\n  color: #282c34;\r\n  background-color: white;\r\n  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);\r\n}\r\n\r\n.table100width {\r\n  width: 100%;\r\n}\r\n\r\n.removemarginpadding {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.whitespacewrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n.logocustom {\r\n  color: yellow;\r\n  /* background-color: ; */\r\n  /* border: #29008a;\r\n  border-color: #29008a; */\r\n  /* border-bottom: 1px solid lightslategray;\r\n  border-top: 1px solid #61dafb;\r\n  border-left: 1px solid #61dafb;\r\n  border-right: 1px solid #61dafb; */\r\n\r\n  margin: 3px;\r\n}\r\n.wishlistbutton {\r\n  border-color: pink;\r\n  color: pink;\r\n  background-color: white;\r\n  border: 3px solid white;\r\n  border-bottom: -3px solid white;\r\n  border-top: -3px solid white;\r\n  border-left: -3px solid white;\r\n  border-right: -3px solid white;\r\n}\r\n\r\n.cartcustom {\r\n  color: yellow;\r\n  /* background-color: ; */\r\n  /* border: #29008a;\r\n  border-color: #29008a; */\r\n  /* border-bottom: 1px solid lightslategray;\r\n  border-top: 1px solid #61dafb;\r\n  border-left: 1px solid #61dafb;\r\n  border-right: 1px solid #61dafb; */\r\n\r\n  margin: 3px;\r\n}\r\n.tablenopadding {\r\n  padding: 0 !important;\r\n}\r\n.cartcustom:hover {\r\n  color: black !important;\r\n  border: white;\r\n  background-color: white;\r\n}\r\n\r\n.accordionheadertitle {\r\n  /* font-family: Arial, Helvetica, sans-serif; */\r\n  font-size: 26px;\r\n}\r\n\r\n.offcanvas-top.h-auto {\r\n  bottom: initial;\r\n}\r\n\r\n.blink_me {\r\n  animation: blinker 1s linear infinite;\r\n}\r\n\r\n@keyframes blinker {\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.completeorderbtn {\r\n  background-color: yellow;\r\n}\r\n.completeorderbtn:hover {\r\n  background-color: yellowgreen;\r\n}\r\n\r\n.costfont {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  /* font-size: 16px !important; */\r\n  /* color: black; */\r\n}\r\n\r\n.productNamewrap {\r\n  overflow-wrap: break-word;\r\n  white-space: normal;\r\n}\r\n\r\n.paymentcontainercustom {\r\n  background-color: white;\r\n  border: 1px solid burlywood;\r\n  /* font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif,\r\n    \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif; */\r\n}\r\n\r\n/* .MobileApp {\r\n  color: #228b22;\r\n  text-align: center;\r\n} */\r\n/* .footer {\r\n  background-color: black;\r\n  position: fixed;\r\n  width: 100%;\r\n  bottom: 0;\r\n  color: white;\r\n  font-size: 24px;\r\n  margin-top: 0%;\r\n  padding-top: 0%;\r\n  padding-bottom: 0px;\r\n} */\r\n\r\n/* .footer {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background-color: rgb(235, 195, 64);\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n} */\r\n\r\n/* .footer {\r\n  background-color: green;\r\n  border-top: 2px solid red;\r\n  position: fixed;\r\n  width: 100%;\r\n  bottom: 0;\r\n  color: white;\r\n  font-size: 25px;\r\n} */\r\n.content-container {\r\n  min-height: calc(0vh - 34px);\r\n}\r\n.footer--pin {\r\n  position: fixed;\r\n  background-color: black;\r\n  border-top: 5px solid red;\r\n  color: red;\r\n\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  margin-top: 0%;\r\n  padding-top: 0px;\r\n  padding-bottom: 15px;\r\n  font-size: 10px;\r\n}\r\n\r\n.orderpage2background {\r\n  background-color: gainsboro;\r\n}\r\n.orderpage2backgroundMobile {\r\n  background-color: aliceblue;\r\n}\r\n.checkoutform {\r\n  background-color: whitesmoke;\r\n  /* border: 2px solid black; */\r\n}\r\n\r\n/* .homebackground {\r\n  background-color: #5c9cdc;\r\n  color: black;  \r\n  font-size: 14px;\r\n} */\r\n.mainnavbarborder {\r\n  padding-bottom: 0%;\r\n  border-bottom: 5px solid #20143c;\r\n}\r\n.mainnavbarlight {\r\n  padding-bottom: 0%;\r\n  border-bottom: 1px inset lightgrey;\r\n}\r\n/* .storetitle {\r\n  color: #20143c;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-size: 20px;\r\n} */\r\n/* .subnavbarcolor {\r\n  background-color: #20143c;\r\n  color: black;  \r\n  font-size: 14px;\r\n} */\r\n.addtocartbutton {\r\n  background-color: #20143c;\r\n  color: white;\r\n  font-size: 14px;\r\n}\r\n.viewallbutton {\r\n  background-color: #20143c;\r\n  color: white;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  text-align: right;\r\n  margin-right: 1em;\r\n  justify-content: end;\r\n}\r\n\r\n.primarythemecolor {\r\n  background-color: #20143c;\r\n}\r\n\r\n.mainbackground {\r\n  /* background-color: cornsilk; */\r\n  /* background-color: aliceblue; */\r\n  background-color: white;\r\n}\r\n\r\n.cartviewbarcolor {\r\n  background-color: #f5f5f5;\r\n  color: black;\r\n  /* background-color: #29008a; */\r\n  font-size: 14px;\r\n}\r\n\r\n.space_lg {\r\n  width: 200px;\r\n}\r\n\r\n.mrpfontsize {\r\n  font-size: 22px;\r\n}\r\n\r\n.card-round {\r\n  border-radius: 15px 15px 15px 15px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.cardimage-round {\r\n  border-radius: 20px 20px 20px 20px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.TopCornerRounded {\r\n  border-radius: 30px 30px 0px 00px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.TopCornerRoundedSmall {\r\n  border-radius: 10px 10px 0px 00px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.CornersHalfRounded {\r\n  border-radius: 30px 0px 30px 0px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.leftCornersHalfRounded {\r\n  border-radius: 50px 50px 50px 0px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.CornersRounded {\r\n  border-radius: 30px 30px 30px 30px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.CornersRoundedSmall-v1 {\r\n  border-radius: 10px 10px 10px 10px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.CornersRoundedBig {\r\n  border-radius: 50px 50px 50px 50px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.ProductCardRounded {\r\n  border-radius: 50px 50px 50px 50px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.ProductImageTopRounded {\r\n  border-radius: 15px 15px 0px 00px;\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.CornersRoundedMenu {\r\n  /* margin: 10px;\r\n  border-radius: 130px 130px 130px 130px;\r\n  margin-left: 100px;\r\n  margin-right: 100px;\r\n  position: relative;\r\n  margin-top: 0px;\r\n  z-index: 950; */\r\n}\r\n.carouselalign {\r\n  /* position: relative;\r\n  margin-top: -120px;\r\n  z-index: 900; */\r\n}\r\n.bannervideo {\r\n  position: relative;\r\n  margin-top: -120px;\r\n  z-index: 900;\r\n}\r\n.bannervideomobile {\r\n  position: relative;\r\n  margin-top: 0px;\r\n  z-index: 900;\r\n}\r\n\r\n.buttonRounded {\r\n  border-radius: 20px 20px 20px 20px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n.buttonRoundedSmall {\r\n  border-radius: 5px 5px 5px 5px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.card-right {\r\n  border-radius: 0 30px 30px 0;\r\n}\r\n\r\n.productmodal-body {\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.categorydiv {\r\n  margin: 1px, 1px;\r\n  padding: 1px;\r\n  background-color: green;\r\n  width: 100%;\r\n  height: 300px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  text-align: justify;\r\n}\r\n\r\n.item {\r\n  position: relative;\r\n  padding-top: 10px;\r\n  display: inline-block;\r\n}\r\n.notify-badge-left {\r\n  position: absolute;\r\n  left: 0px;\r\n  /* right: -20px; */\r\n  top: 10px;\r\n  background: gray;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: white;\r\n  padding: 5px 10px;\r\n  font-size: 10px;\r\n}\r\n\r\n.notify-badge-right {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 15px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n.notify-badge-right_share {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 15px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n.notify-maincategory-badge-right_share {\r\n  position: absolute;\r\n  right: 45px;\r\n  top: 25px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n.notify-subcategory-badge-right_share {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 15px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n.notify-maincategory-mobile-badge-right_share {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 20px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n.notify-subcategory-mobile-badge-right_share {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 0px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n\r\n.notify-badge-right-mobile-wishlist {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 10px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 5px;\r\n  font-size: 10px;\r\n}\r\n\r\n.notify-badge-wishlist {\r\n  position: relative;\r\n  right: 4px;\r\n  top: -16px;\r\n\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n}\r\n\r\n.notify-badge-quote-wishlist {\r\n  position: relative;\r\n  right: -5px;\r\n  top: -10px;\r\n\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n}\r\n.notify-badge-cart {\r\n  position: relative;\r\n  right: 5px;\r\n  top: -15px;\r\n\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n  width: 25px;\r\n  height: 25px;\r\n  display: inline-block;\r\n}\r\n\r\n.notify-badge-wishlist-mobile {\r\n  /* position: absolute;\r\n  right: 35px;\r\n  top: 10px; */\r\n\r\n  position: relative;\r\n  right: 5px;\r\n  top: -17px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: blue;\r\n  padding: 6px 8px;\r\n  font-size: 10px;\r\n}\r\n.notify-badge-cart-mobile {\r\n  position: relative;\r\n  top: -18px;\r\n  right: 10px;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n}\r\n.notify-badge-wishlist-OnSinglePageView-mobile {\r\n  position: absolute;\r\n  /* left: 50px; */\r\n  right: 20px;\r\n  top: 10px;\r\n  /* background: gray; */\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: white;\r\n  padding: 10px 10px;\r\n  font-size: 10px;\r\n  /* position: relative;\r\n  right: -35px;\r\n  top: 0px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: blue;\r\n  padding: 5px 8px;\r\n  font-size: 8px; */\r\n}\r\n\r\n.react__slick__slider__parent {\r\n  position: relative;\r\n  /* place-items: center; */\r\n  margin: auto;\r\n  left: auto;\r\n}\r\n\r\n.slick-slide img {\r\n  margin: auto;\r\n  left: auto;\r\n}\r\np.img-slide-text {\r\n  margin: 2rem auto 0;\r\n}\r\n\r\n.react__slick__slider__parent .slick-prev,\r\n.react__slick__slider__parent .slick-next {\r\n  /* position: absolute; */\r\n  position: absolute;\r\n  top: 50%;\r\n}\r\n.react__slick__slider__parent .slick-prev {\r\n  border-radius: 50%;\r\n  color: black;\r\n  z-index: 1;\r\n}\r\n.react__slick__slider__parent .slick-next {\r\n  border-radius: 50%;\r\n  color: black;\r\n  z-index: 1;\r\n}\r\n.react__slick__slider__parent .slick-prev::before {\r\n  color: black;\r\n}\r\n.react__slick__slider__parent .slick-next::before {\r\n  color: black;\r\n}\r\n\r\n.react__slick__slider__parent1 {\r\n  position: relative;\r\n}\r\n\r\n/* .react__slick__slider__parent1 .slick-prev,\r\n.react__slick__slider__parent1 .slick-next {\r\n  position: absolute;\r\n  color: black;\r\n  top: 40%;\r\n} */\r\n.react__slick__slider__parent1 .slick-prev {\r\n  border-radius: 50%;\r\n  color: black;\r\n  background-color: #008f2f;\r\n  z-index: 1;\r\n}\r\n\r\n.react__slick__slider__parent1 .slick-next {\r\n  border-radius: 50%;\r\n  color: black;\r\n  z-index: 1;\r\n}\r\n.react__slick__slider__parent1 .slick-prev::before {\r\n  color: black;\r\n}\r\n.react__slick__slider__parent1 .slick-next::before {\r\n  color: black;\r\n}\r\n\r\n.slick-prev {\r\n  left: -2% !important;\r\n  z-index: 1;\r\n}\r\n.slick-next {\r\n  right: -2% !important;\r\n  z-index: 1;\r\n}\r\n\r\n.invertimage {\r\n  filter: invert(100%);\r\n}\r\n\r\n.homefooter {\r\n  background-color: #282c34;\r\n\r\n  /* min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin); */\r\n  color: white;\r\n}\r\n\r\n.signupmobilenoandotp {\r\n  font-size: 18px;\r\n}\r\n\r\n.xxlmodal {\r\n  width: 90vw; /* Occupy the 90% of the screen width */\r\n  max-width: 90vw;\r\n}\r\n\r\n.whats-app {\r\n  position: fixed;\r\n  width: 50px;\r\n  height: 50px;\r\n  bottom: 60px;\r\n  background-color: #25d366;\r\n  color: #fff;\r\n  border-radius: 50px;\r\n  text-align: center;\r\n  font-size: 30px;\r\n  box-shadow: 3px 4px 15px 0px #00000052;\r\n  /* left: 15px; */\r\n  right: 15px;\r\n  z-index: 100;\r\n  padding: 3px;\r\n}\r\n.shop-now {\r\n  position: fixed;\r\n  /* margin: 0; */\r\n  /* position: absolute; */\r\n  top: 50%;\r\n  /* width: 150px;\r\n  height: 50px; */\r\n  /* bottom: 140px; */\r\n  /* background-color: #25d366; */\r\n  color: #fff;\r\n  /* border-radius: 50px; */\r\n  text-align: center;\r\n  font-size: 30px;\r\n  font-family: \"Franklin Gothic Medium\", \"Arial Narrow\", Arial, sans-serif;\r\n  /* box-shadow: 3px 4px 3px #999; */\r\n  /* left: 15px; */\r\n  /* right: 15px; */\r\n  right: 2%;\r\n  z-index: 100;\r\n  /* padding: 3px; */\r\n}\r\n.shop-now-mobile {\r\n  position: fixed;\r\n  /* margin: 0; */\r\n  /* position: absolute; */\r\n  top: 50%;\r\n  /* width: 150px;\r\n  height: 50px; */\r\n  /* bottom: 140px; */\r\n  /* background-color: #25d366; */\r\n  color: #fff;\r\n  /* border-radius: 50px; */\r\n  text-align: center;\r\n  font-size: 30px;\r\n  font-family: \"Franklin Gothic Medium\", \"Arial Narrow\", Arial, sans-serif;\r\n  /* box-shadow: 3px 4px 3px #999; */\r\n  /* left: 15px; */\r\n  /* right: 15px; */\r\n  right: 2%;\r\n  z-index: 100;\r\n  /* padding: 3px; */\r\n}\r\n\r\n.my-float {\r\n  margin-top: 10px;\r\n}\r\n.zoom {\r\n  /* padding: 50px;\r\n  background-color: green;\r\n  transition: transform 0.2s; \r\n  width: 200px;\r\n  height: 200px;\r\n  margin: 0 auto; */\r\n  width: \"100%\";\r\n  /* height: 300px; */\r\n  overflow: auto;\r\n  margin: 0 auto;\r\n}\r\n\r\n.zoom img {\r\n  width: 100%;\r\n  transition: 0.5s all ease-in-out;\r\n}\r\n.zoom:hover {\r\n  transform: scale(\r\n    1.1\r\n  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\r\n}\r\n\r\n.img-hover-mover:hover {\r\n  -webkit-animation: mover 2s infinite alternate;\r\n  animation: mover 2s infinite alternate;\r\n}\r\n@-webkit-keyframes mover {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n@keyframes mover {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n.img-hover-zoom {\r\n  /* height: 300px; [1.1] Set it as per your need */\r\n  overflow: hidden; /* [1.2] Hide the overflowing of child elements */\r\n}\r\n\r\n/* [2] Transition property for smooth transformation of images */\r\n.img-hover-zoom img {\r\n  transition: transform 0.5s ease;\r\n}\r\n\r\n.img-hover-zoom video {\r\n  transition: transform 0.5s ease;\r\n}\r\n\r\n/* [3] Finally, transforming the image when container gets hovered */\r\n.img-hover-zoom:hover img {\r\n  transform: scale(1.2);\r\n}\r\n.img-hover-zoom:hover video {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.image-blurred-edge {\r\n  /* width: 200px;\r\n  height: 200px; */\r\n  /* you need to match the shadow color to your background or image border for the desired effect*/\r\n  /* box-shadow: 0 0 8px 8px white inset; */\r\n  /* filter: blur(5px); */\r\n  width: 100%;\r\n  /* position: absolute; */\r\n  /* bottom: 0px;\r\n  top: 0px; */\r\n  box-shadow: inset -10px -10px 10px 20px white;\r\n}\r\n\r\n.spinnermodal-backdrop {\r\n  backdrop-filter: blur(0px);\r\n  /* filter: blur(0px); */\r\n  -webkit-filter: blur(0px);\r\n  background-color: #01223770;\r\n  /* background-color: orange; */\r\n}\r\n.spinnermodal-backdrop.in {\r\n  opacity: 100 !important;\r\n}\r\n.spinnermodalcenter {\r\n  display: flex !important;\r\n  width: 100% !important;\r\n  pointer-events: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.loadspinnermodalalign {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.adshover:hover {\r\n  object-fit: \"cover\";\r\n}\r\n\r\n.slick-dots {\r\n  margin-top: 55px;\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n  display: flex;\r\n  justify-content: center;\r\n  li {\r\n    list-style: none;\r\n    display: inline-block;\r\n    max-width: 50px;\r\n    max-height: 56px;\r\n    margin: 5px;\r\n\r\n    img {\r\n      opacity: 0.5;\r\n      width: 80%;\r\n      height: auto;\r\n    }\r\n\r\n    &.slick-active {\r\n      img {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.paymentmode {\r\n  font-size: 16px;\r\n  /* left: -100px; */\r\n  font-size: 20px;\r\n  letter-spacing: 5px;\r\n  display: inline-block;\r\n  transform: rotate(270deg);\r\n  /* left: -170px; */\r\n  /* top: calc(50% - 30px); */\r\n  top: 200px;\r\n  position: relative;\r\n  /* top: 100px;\r\n  position: absolute; */\r\n  text-transform: uppercase;\r\n}\r\n\r\n.single-item a.btn-dgn-2 {\r\n  color: #008f2f;\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  position: relative;\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n}\r\n.single-item a {\r\n  text-decoration: none;\r\n  display: inline-block;\r\n}\r\n.single-item a.btn-dgn-2:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 0%;\r\n  height: 1px;\r\n  background: #008f2f;\r\n  left: 0;\r\n  transition: 0.5s;\r\n}\r\n\r\n.single-item a.btn-dgn-2:after {\r\n  content: \"\\f105\";\r\n  display: inline-block;\r\n  font: normal normal normal 14px/1 FontAwesome;\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  position: relative;\r\n  right: -5px;\r\n  transition: 0.5s;\r\n}\r\n\r\n.single-item a.btn-dgn-2:hover:after {\r\n  right: -2px;\r\n}\r\n\r\n.single-item a.btn-dgn-2:hover:before {\r\n  width: 100%;\r\n}\r\n\r\n.video-container {\r\n  position: relative;\r\n  padding-bottom: calc(var(--aspect-ratio, 0.5625) * 100%);\r\n  height: 0;\r\n  width: 100%;\r\n}\r\n\r\n.video-container iframe {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 1000px;\r\n}\r\n\r\n.slick-slide.slick-center img {\r\n  /* transform: scale(1.2); */\r\n  background-color: yellow;\r\n}\r\n.slick-slide.slick-center Table {\r\n  /* background-color: yellow; */\r\n  /* font-weight: bold;\r\n  font-size: larger; */\r\n}\r\n\r\n.count-grp {\r\n  padding: 25px 50px;\r\n  /* background-color: #fff; */\r\n  border-radius: 15px;\r\n  box-shadow: 2px 3px 12px -9px #000000ad;\r\n}\r\n.count-grp h3 {\r\n  font-size: 45px;\r\n}\r\n.count-grp h5 {\r\n  font-size: 17px;\r\n  letter-spacing: 1.5px;\r\n}\r\n\r\n.count-grp-mobile {\r\n  padding: 5px 5px;\r\n  background-color: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 2px 3px 12px -9px #000000ad;\r\n}\r\n.count-grp-mobile h3 {\r\n  font-size: 30px;\r\n}\r\n.count-grp-mobile h5 {\r\n  font-size: 12px;\r\n  letter-spacing: 1.5px;\r\n}\r\n\r\n.scroll-without-scrollbar {\r\n  -ms-overflow-style: none; /* for Internet Explorer, Edge */\r\n  scrollbar-width: none; /* for Firefox */\r\n  overflow-y: scroll;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.scroll-without-scrollbar::-webkit-scrollbar {\r\n  display: none; /* for Chrome, Safari, and Opera */\r\n}\r\n\r\n.visitorscount {\r\n  position: relative;\r\n  top: 0px;\r\n\r\n  /* padding: 5px 8px; */\r\n  font-size: 12px;\r\n}\r\n\r\n.thumbnaillist-group {\r\n  /* max-height: 550px;\r\n  margin-bottom: 10px; */\r\n  /* overflow: scroll; */\r\n  overflow-x: scroll;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.base-class {\r\n  background-color: white;\r\n  border: 1;\r\n  border-color: lightgray;\r\n}\r\n.active-color {\r\n  background-color: white;\r\n  border: 1;\r\n  border-color: black;\r\n}\r\n\r\n.hover-underline-animation {\r\n  display: inline-block;\r\n  position: relative;\r\n  color: #0087ca;\r\n}\r\n\r\n.hover-underline-animation::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  transform: scaleX(0);\r\n  height: 2px;\r\n  bottom: 0;\r\n  left: 0;\r\n  background-color: #0087ca;\r\n  transform-origin: bottom right;\r\n  transition: transform 0.25s ease-out;\r\n}\r\n\r\n.hover-underline-animation:hover::after {\r\n  transform: scaleX(1);\r\n  transform-origin: bottom left;\r\n}\r\n\r\n/* @media only screen and (max-width: 2000px) { */\r\n.ectittle-black-outline-5 {\r\n  font-family: \"Raleway Black\";\r\n  -webkit-text-stroke-width: 1px;\r\n  -webkit-text-stroke-color: #30303050;\r\n  font-size: 60px;\r\n  color: transparent;\r\n  display: inline-block;\r\n  transform: rotate(0deg);\r\n  left: 350px;\r\n  /* left: -156px; */\r\n  /* top: 350px; */\r\n  /* top: calc(50% - 50px); */\r\n  position: absolute;\r\n  text-transform: uppercase;\r\n}\r\n.ectittle-black-outline-kiosk {\r\n  font-family: \"Raleway Black\";\r\n  -webkit-text-stroke-width: 1px;\r\n  -webkit-text-stroke-color: #30303050;\r\n  font-size: 120px;\r\n  color: transparent;\r\n  display: inline-block;\r\n  /* transform: rotate(0deg); */\r\n  /* left: 350px; */\r\n  text-align: center;\r\n  /* left: -156px; */\r\n  /* top: 350px; */\r\n  /* top: calc(50% - 50px); */\r\n  /* position: absolute; */\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n/* } */\r\n\r\n@media only screen and (max-width: 1366px) {\r\n  .ectittle-black-outline-5 {\r\n    font-family: \"Raleway Black\";\r\n    -webkit-text-stroke-width: 1px;\r\n    -webkit-text-stroke-color: #30303050;\r\n    font-size: 60px;\r\n    color: transparent;\r\n    display: inline-block;\r\n    transform: rotate(0deg);\r\n    left: 200px;\r\n    /* left: -156px; */\r\n    /* top: 350px; */\r\n    /* top: calc(50% - 50px); */\r\n    position: absolute;\r\n    text-transform: uppercase;\r\n  }\r\n}\r\n\r\n.ectittle-black-outline-mobile {\r\n  font-family: \"Raleway Black\";\r\n  -webkit-text-stroke-width: 1px;\r\n  -webkit-text-stroke-color: #30303050;\r\n  font-size: 60px;\r\n  color: transparent;\r\n  display: inline-block;\r\n  transform: rotate(0deg);\r\n  left: 30px;\r\n  /* left: -156px; */\r\n  /* top: 350px; */\r\n  /* top: calc(50% - 50px); */\r\n  position: absolute;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.bankreceiptheight {\r\n  margin: 1px, 1px;\r\n  padding: 1px;\r\n  /* background-color: green; */\r\n  width: 100%;\r\n  height: 200px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  text-align: justify;\r\n}\r\n\r\n.verticalaligncenterstart {\r\n  /* vertical-align: middle; */\r\n  display: flex;\r\n  vertical-align: middle;\r\n  align-items: start;\r\n  justify-content: start;\r\n  z-index: 9999;\r\n}\r\n\r\n.btn-green-2 {\r\n  /* background: #008f2f; */\r\n  background-image: linear-gradient(to right, #008f2f, #04cd46);\r\n  background-color: #4ad168;\r\n  border: 1px solid #008f2f;\r\n  padding: 7px;\r\n  color: #fff;\r\n  width: 125px;\r\n  letter-spacing: 0.5px;\r\n  font-size: 14px;\r\n  transition: 0.5s;\r\n}\r\n.btn-green-2:hover {\r\n  /* background: #007a28; */\r\n  color: #fff;\r\n  box-shadow: 0 26px 25px -19px #00000063;\r\n  border-radius: 10px;\r\n}\r\n\r\n.inputboxunderline {\r\n  width: 100%;\r\n  padding: 2px 2px;\r\n  margin: 2px 0;\r\n  box-sizing: border-box;\r\n  border: none;\r\n  border-bottom: 2px solid lightgray;\r\n}\r\n\r\n.image-container-for-button {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n.image-container-for-button video {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.image-container-for-button .btn1 {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  background-color: #555;\r\n  color: white;\r\n  font-size: 16px;\r\n  padding: 12px 24px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n.image-container-for-button .btn1:hover {\r\n  background-color: black;\r\n}\r\n\r\n/* CheckOut Page 12-3-2024 */\r\ndiv.checkout-container {\r\n  max-width: 1780px;\r\n  margin: 0 auto !important;\r\n  position: relative;\r\n  margin-bottom: 100px !important;\r\n}\r\n.checkout-container .inner-row {\r\n  padding-left: 130px !important;\r\n}\r\n.checkout-container .ectittle-black-outline-5 {\r\n  transform: rotate(270deg);\r\n  left: -200px;\r\n  top: 300px;\r\n  font-size: 98px;\r\n}\r\n.checkout-container .hstack h5 {\r\n  margin-bottom: 0px;\r\n}\r\n.checkout-container .checkout-lef-col .form-control,\r\n.checkout-container .checkout-lef-col .form-select {\r\n  border: 0px;\r\n  border-bottom: 1px solid #757575;\r\n  border-radius: 0px;\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n  height: calc(4.3rem + 2px) !important;\r\n  padding-top: 2.5rem !important;\r\n}\r\n.checkout-container .form-floating label {\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n  font-size: 18px;\r\n  color: #999999;\r\n}\r\n.checkout-container .form-check-label h5 {\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n}\r\n.form-check-control .form-check {\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.bank-statement-section .bankreceiptheight {\r\n  padding: 15px 15px 0;\r\n  height: 290px;\r\n}\r\n.bank-statement-section .bankreceiptheight h2 {\r\n  font-size: 16px;\r\n  font-family: \"Raleway SemiBold\";\r\n}\r\n.bank-statement-section .bankreceiptheight th,\r\n.bank-statement-section .bankreceiptheight td {\r\n  font-size: 15px;\r\n  vertical-align: top;\r\n  min-width: 185px;\r\n  font-weight: 400;\r\n  padding-bottom: 15px;\r\n}\r\n.bank-statement-section .bankreceiptheight td {\r\n  color: #000000;\r\n}\r\n.delivery-note,\r\n.delivery-note + span {\r\n  font-size: 11px;\r\n}\r\n.delivery-note::before {\r\n  content: \"*\";\r\n  font-size: 27px;\r\n  color: #f1587b;\r\n  line-height: 1;\r\n  vertical-align: top;\r\n  display: inline-block;\r\n  margin-right: 4px;\r\n  position: relative;\r\n  top: 4px;\r\n  margin-left: -8px;\r\n}\r\n.delivery-note b {\r\n  font-weight: normal;\r\n}\r\n.bank-statement-section .bankreceiptheight i {\r\n  font-style: normal;\r\n  font-size: 15px;\r\n  color: #000000;\r\n  background-color: #e9f8ee;\r\n  display: block;\r\n  padding: 0 15px 15px;\r\n  margin: 20px -15px 0;\r\n}\r\n.bank-statement-section .bankreceiptheight i b {\r\n  font-weight: normal;\r\n}\r\n.bank-statement-section .bankreceiptheight i b u {\r\n  color: #3c4242;\r\n  text-decoration: none;\r\n}\r\n.checkout-container button.btn-green-2 {\r\n  background: linear-gradient(30deg, #36dd68 0%, #dddf78 100%);\r\n  border: 0px;\r\n  font-size: 16px;\r\n  font-family: \"Raleway Bold\";\r\n  width: auto;\r\n  padding: 10px 26px;\r\n}\r\n.checkout-right {\r\n  padding-top: 80px;\r\n}\r\n.checkout-right h4 {\r\n  font-size: 20px;\r\n  color: #303030;\r\n  margin-bottom: 20px;\r\n}\r\n.checkout-right h4 .item-count {\r\n  font-size: 14px;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  background-color: #db4437;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  top: -3px;\r\n  left: 5px;\r\n}\r\n.checkout-right .table-responsive-md {\r\n  border-top: 1px solid #e5e4e4;\r\n  margin-top: 5px;\r\n  padding-top: 15px;\r\n}\r\n.checkout-right .table-responsive-md .table > :not(:first-child) {\r\n  border-top: 0px;\r\n}\r\n.checkout-right .table-responsive-md th {\r\n  font-size: 15px;\r\n  font-family: \"Raleway Bold\";\r\n  /*text-align: left;*/\r\n}\r\n.checkout-right .table-responsive-md td {\r\n  font-size: 16px;\r\n}\r\n.checkout-right .table-responsive-md td.col-md-1 {\r\n  padding-top: 0px;\r\n}\r\n.checkout-right .table-responsive-md .table > :not(caption) > * > * {\r\n  border: 0px;\r\n}\r\n.checkout-right .table-responsive-md td button.rounded-circle {\r\n  outline: 0px !important;\r\n  box-shadow: none;\r\n}\r\n.incdectable input {\r\n  width: 59px;\r\n  /* background: transparent !important; */\r\n  margin: 0 6px;\r\n}\r\n.delivery-method .form-check {\r\n  margin-bottom: 0px;\r\n}\r\n.delivery-method .form-check input {\r\n  position: relative;\r\n  opacity: 0;\r\n}\r\n.delivery-method .form-check label {\r\n  position: relative;\r\n}\r\n.delivery-method .form-check label:before {\r\n  width: 17px;\r\n  height: 17px;\r\n  content: \"\";\r\n  border-radius: 50%;\r\n  border: 2px solid #dcdcdc;\r\n  position: absolute;\r\n  left: -23px;\r\n  top: 3px;\r\n}\r\n.delivery-method .form-check label:after {\r\n  width: 9px;\r\n  height: 9px;\r\n  content: \"\";\r\n  border-radius: 50%;\r\n  background-color: #23b14d;\r\n  position: absolute;\r\n  left: -19px;\r\n  top: 7px;\r\n  opacity: 0;\r\n  transition: all 0.4s ease;\r\n  transform: scale(0);\r\n}\r\n.delivery-method .form-check input:checked + label:before {\r\n  border-color: #23b14d;\r\n}\r\n.delivery-method .form-check input:checked + label:after {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n.order-summary h4 {\r\n  border-bottom: 1px solid #e5e4e4;\r\n  padding-bottom: 18px;\r\n  margin-bottom: 5px;\r\n}\r\n.order-details {\r\n  font-size: 16px;\r\n  color: #303030;\r\n}\r\n.order-details .row {\r\n  margin-bottom: 10px;\r\n}\r\n.order-details .text-end {\r\n  color: #000000;\r\n  font-family: \"Raleway SemiBold\";\r\n}\r\n.order-details hr {\r\n  background-color: #e5e4e4;\r\n  opacity: 1;\r\n}\r\n.total-text h3 {\r\n  color: #595757;\r\n  font-family: \"Raleway SemiBold\";\r\n}\r\n.coupon-code-text {\r\n  color: #303030;\r\n  font-family: \"Raleway SemiBold\";\r\n}\r\n.coupon-code-text .hstack {\r\n  padding-left: 0px;\r\n  margin-top: 10px;\r\n}\r\n.coupon-code-text .hstack input {\r\n  margin-left: 0px !important;\r\n  border: 0px;\r\n  border-bottom: 1px solid #757575;\r\n  border-radius: 0px;\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n  height: 39px !important;\r\n  background-color: transparent !important;\r\n  text-align: left;\r\n  font-size: 13px;\r\n}\r\n.coupon-code-text .hstack input::placeholder {\r\n  color: #999999;\r\n  opacity: 1;\r\n}\r\n.coupon-code-text .hstack input::-webkit-input-placeholder {\r\n  color: #999999;\r\n  opacity: 1;\r\n}\r\n.coupon-code-text .hstack button {\r\n  background: linear-gradient(30deg, #36dd68 0%, #dddf78 100%);\r\n  border: 0px;\r\n  font-size: 16px;\r\n  font-family: \"Raleway Bold\";\r\n  width: auto;\r\n  padding: 8px 26px;\r\n}\r\n.note-text {\r\n  color: #333333;\r\n  font-size: 11px;\r\n  letter-spacing: 0.09px;\r\n  margin-top: 30px !important;\r\n}\r\n.note-text:before {\r\n  content: \"*\";\r\n  font-size: 27px;\r\n  color: #f1587b;\r\n  line-height: 1;\r\n  vertical-align: top;\r\n  display: inline-block;\r\n  margin-right: 4px;\r\n  position: relative;\r\n  top: 0px;\r\n  margin-left: -8px;\r\n}\r\n.note-text:empty:before {\r\n  display: none;\r\n}\r\n.billing-address .bg-light {\r\n  padding: 15px !important;\r\n}\r\n.billing-address .bg-light h6 {\r\n  margin-bottom: 0px !important;\r\n}\r\n.billing-address .bg-light h6 label {\r\n  font-size: 18px;\r\n}\r\n.billing-address input[type=\"radio\"] {\r\n  position: relative;\r\n  opacity: 0;\r\n}\r\n.billing-address label {\r\n  position: relative;\r\n}\r\n.billing-address input[type=\"radio\"] + label:before {\r\n  width: 17px;\r\n  height: 17px;\r\n  content: \"\";\r\n  border-radius: 50%;\r\n  border: 2px solid #dcdcdc;\r\n  position: absolute;\r\n  left: -23px;\r\n  top: 3px;\r\n}\r\n.billing-address input[type=\"radio\"] + label:after {\r\n  width: 9px;\r\n  height: 9px;\r\n  content: \"\";\r\n  border-radius: 50%;\r\n  background-color: #23b14d;\r\n  position: absolute;\r\n  left: -19px;\r\n  top: 7px;\r\n  opacity: 0;\r\n  transition: all 0.4s ease;\r\n  transform: scale(0);\r\n}\r\n.bank-statement-section input[type=\"radio\"] + label:before {\r\n  top: 2px;\r\n}\r\n.bank-statement-section input[type=\"radio\"] + label:after {\r\n  top: 6px;\r\n}\r\n.billing-address input[type=\"radio\"]:checked + label:before {\r\n  border-color: #23b14d;\r\n}\r\n.billing-address input[type=\"radio\"]:checked + label:after {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n.billing-detail {\r\n  font-size: 16.5px;\r\n  line-height: 1.5;\r\n  color: #000000;\r\n}\r\n.payment-mode {\r\n  font-size: 17px;\r\n  font-family: \"Raleway SemiBold\";\r\n}\r\n.cartviewtableOnCheckout tbody > tr > td {\r\n  padding-bottom: 20px;\r\n}\r\n/* Common Changes */\r\n/* .offcanvas-header .offcanvas-title {\r\n  color: rgb(35, 177, 77);\r\n} */\r\n.card h2 {\r\n  font-size: 19px !important;\r\n  padding: 0 5px;\r\n}\r\n.thumbnaillist-group .base-class {\r\n  background-color: #ebebeb;\r\n}\r\n.active-color.list-group-item {\r\n  border-color: rgb(35, 177, 77);\r\n  border-width: 2px;\r\n}\r\n.slider_white_bg.carousel-caption {\r\n  background-color: rgba(255, 255, 255, 0.5) !important;\r\n  opacity: 1 !important;\r\n}\r\n.content_part h1 {\r\n  line-height: 1.2 !important;\r\n}\r\nbody .text-success {\r\n  color: rgb(35, 177, 77) !important;\r\n}\r\n.single-item a.btn-dgn-2 {\r\n  color: rgb(35, 177, 77) !important;\r\n}\r\n.btn-primary.btn-green {\r\n  border-width: 0px;\r\n}\r\n.thumbnaillist-group {\r\n  overflow-x: auto !important;\r\n}\r\n/* .navbar-collapse svg {\r\n  color: rgb(35, 177, 77) !important;\r\n} */\r\n.offcanvas-body .searchboxconoffcanvas {\r\n  border: none;\r\n  border-bottom: 1px solid #757575;\r\n  border-radius: 0px;\r\n}\r\n.search-wrap svg {\r\n  max-width: 20px;\r\n}\r\n/* @media screen and (-webkit-min-device-pixel-ratio:0) {\r\n  input[type='range'] {\r\n    overflow: hidden;\r\n    width: 80px;\r\n    -webkit-appearance: none;\r\n    background-color: #9a905d;\r\n  }\r\n  \r\n  input[type='range']::-webkit-slider-runnable-track {\r\n    height: 10px;\r\n    -webkit-appearance: none;\r\n    color: #13bba4;\r\n    margin-top: -1px;\r\n  }\r\n \r\n\r\n} */\r\n\r\ninput[type=\"range\"]::-webkit-slider-runnable-track {\r\n  background: #b8e3c5 !important;\r\n  height: 7px !important;\r\n}\r\ninput[type=\"range\"]::-webkit-slider-thumb {\r\n  -webkit-appearance: none; /* Override default look */\r\n  appearance: none;\r\n  background-color: #23b14d !important;\r\n}\r\n/** FF*/\r\ninput[type=\"range\"]::-moz-range-progress {\r\n  background-color: #b8e3c5 !important;\r\n}\r\ninput[type=\"range\"]::-moz-range-track {\r\n  background-color: #9a905d;\r\n}\r\n/* IE*/\r\ninput[type=\"range\"]::-ms-fill-lower {\r\n  background-color: #b8e3c5;\r\n}\r\ninput[type=\"range\"]::-ms-fill-upper {\r\n  background-color: #9a905d;\r\n}\r\n\r\n.UserProfileDsn .form-floating label {\r\n  padding: 0px !important;\r\n}\r\n.moveLabelUp label {\r\n  top: -10px;\r\n}\r\n.moveLabelUp.form-floating > .form-control:not(:placeholder-shown) {\r\n  padding-bottom: 0;\r\n  padding-top: 5px;\r\n}\r\n/* Mobile Checkout*/\r\n@media (max-width: 1101px) {\r\n  .checkout-container-mob .inner-row-mob {\r\n    padding: 0 30px;\r\n  }\r\n  .checkout-container-mob .checkout-mob-title {\r\n    font-size: 18px;\r\n  }\r\n  .bg-light-grey {\r\n    background-color: #f8f8f8;\r\n  }\r\n  .checkout-container-mob .delivery-method .form-check label {\r\n    font-size: 18px;\r\n    line-height: 1.2;\r\n    color: rgb(35, 177, 77);\r\n  }\r\n  .checkout-container-mob .billing-address .lable-only .form-check label {\r\n    font-size: 18px;\r\n    line-height: 1.2;\r\n    color: rgb(35, 177, 77);\r\n  }\r\n  .checkout-container-mob .checkout-lef-col .form-control,\r\n  .checkout-container .checkout-lef-col .form-select {\r\n    background-color: transparent;\r\n  }\r\n  .billing-address .form-check-control:empty {\r\n    padding: 0px !important;\r\n  }\r\n}\r\n@media (max-width: 767px) {\r\n  .checkout-container .ectittle-black-outline-5 {\r\n    transform: rotate(0deg);\r\n    left: 19px;\r\n    top: 0;\r\n    font-size: 40px;\r\n    position: absolute;\r\n  }\r\n  .checkout-container .inner-row {\r\n    padding-left: 0px !important;\r\n  }\r\n  .billing-address .bg-light h6 label {\r\n    font-size: 13px;\r\n  }\r\n  .billing-address input[type=\"radio\"] + label:after {\r\n    top: 4px;\r\n  }\r\n  .billing-address input[type=\"radio\"] + label:before {\r\n    top: 0px;\r\n  }\r\n  .checkout-container-mob .delivery-method .form-check label {\r\n    font-size: 14px;\r\n  }\r\n  .checkout-container-mob .billing-address .lable-only .form-check label {\r\n    font-size: 14px;\r\n  }\r\n  .bank-statement-section .bankreceiptheight th,\r\n  .bank-statement-section .bankreceiptheight td {\r\n    display: block;\r\n    padding-bottom: 0px;\r\n  }\r\n  .bank-statement-section .bankreceiptheight td {\r\n    padding-bottom: 20px;\r\n  }\r\n  .checkout-right.p-0 {\r\n    padding: 10px 0px 0 !important;\r\n  }\r\n  .checkout-right .table-responsive-md td {\r\n    font-size: 13px;\r\n  }\r\n  .coupon-code-text .hstack button {\r\n    font-size: 14px;\r\n    padding: 8px 41px;\r\n    width: auto;\r\n    min-width: inherit;\r\n  }\r\n  .bank-statement-section .bankreceiptheight i {\r\n    font-size: 14px;\r\n  }\r\n  .bank-statement-section .bankreceiptheight th,\r\n  .bank-statement-section .bankreceiptheight td {\r\n    font-size: 14px;\r\n  }\r\n  .checkout-container .form-floating label {\r\n    font-size: 15px;\r\n  }\r\n  .checkout-container-mob .ectittle-black-outline-mobile {\r\n    font-size: 50px;\r\n  }\r\n  .delivery-method .form-check label:before {\r\n    top: 0;\r\n  }\r\n  .delivery-method .form-check label:after {\r\n    top: 4px;\r\n  }\r\n  .checkout-container .form-check-label h5 {\r\n    font-size: 15px;\r\n  }\r\n  .cartviewtableOnCheckout input {\r\n    margin: 0 5px;\r\n  }\r\n  .bank-statement-section .bankreceiptheight {\r\n    height: auto;\r\n  }\r\n  .checkout-right .table-responsive-md th {\r\n    font-size: 13px;\r\n  }\r\n  .order-details {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.textonimagecentered {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.textonimagebottom {\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: 200px;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.textonimagebottommobile {\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: 75px;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.ribbonright {\r\n  width: 60px;\r\n  font-size: 14px;\r\n  padding: 4px;\r\n  position: absolute;\r\n  right: -5px;\r\n  top: 0px;\r\n  text-align: center;\r\n  border-radius: 25px;\r\n  transform: rotate(20deg);\r\n  background-color: #ff9800;\r\n  color: white;\r\n}\r\n\r\n.ribboncorners {\r\n  border-radius: 10px 0px 10px 0px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.ribbonleft {\r\n  width: 60px;\r\n  font-size: 12px;\r\n  padding: 2px;\r\n  position: absolute;\r\n  /* left: -3px; */\r\n  left: 0px;\r\n  top: 0px;\r\n  text-align: center;\r\n  /* border-radius: 0px; */\r\n  /* transform: rotate(-25deg); */\r\n  /* background-color: darkred; */\r\n  color: white;\r\n}\r\n.ribbonleftgreen {\r\n  width: 60px;\r\n  font-size: 12px;\r\n  padding: 2px;\r\n  position: absolute;\r\n  /* left: -15px; */\r\n  left: 0px;\r\n  top: 0px;\r\n  text-align: center;\r\n  /* border-radius: 0px; */\r\n  /* transform: rotate(-25deg); */\r\n  background-color: #23b14d;\r\n  color: white;\r\n}\r\n\r\n.ribbon-1 {\r\n  position: fixed;\r\n  background: #08769b;\r\n  box-shadow: 0 0 0 999px #08769b;\r\n  clip-path: inset(0 -100%);\r\n}\r\n.left {\r\n  inset: 0 auto auto 0;\r\n  transform-origin: 100% 0;\r\n  transform: translate(-29.3%) rotate(-45deg);\r\n}\r\n.right {\r\n  inset: 0 0 auto auto;\r\n  transform-origin: 0 0;\r\n  transform: translate(29.3%) rotate(45deg);\r\n}\r\n\r\n.ribbonmodernright {\r\n  --f: 10px; /* control the folded part*/\r\n  --r: 15px; /* control the ribbon shape */\r\n  --t: 60px; /* the top offset */\r\n\r\n  position: absolute;\r\n  inset: var(--t) calc(-1 * var(--f)) auto auto;\r\n  padding: 0 10px var(--f) calc(10px + var(--r));\r\n  clip-path: polygon(\r\n    0 0,\r\n    100% 0,\r\n    100% calc(100% - var(--f)),\r\n    calc(100% - var(--f)) 100%,\r\n    calc(100% - var(--f)) calc(100% - var(--f)),\r\n    0 calc(100% - var(--f)),\r\n    var(--r) calc(50% - var(--f) / 2)\r\n  );\r\n  /* background: orangered;\r\n  color: #000000; */\r\n  box-shadow: 0 calc(-1 * var(--f)) 0 inset #0005;\r\n}\r\n\r\n.addcarthide {\r\n  display: none;\r\n}\r\n\r\n.cartDIV:hover + .addcarthide {\r\n  display: block;\r\n  /* color: red; */\r\n}\r\n.addtocartDIV:hover {\r\n  display: block;\r\n  /* color: red; */\r\n}\r\n\r\n.checkoutEditstyle {\r\n  height: auto !important;\r\n  padding-top: 0 !important;\r\n  margin-top: 25px !important;\r\n}\r\n\r\n.glow-border {\r\n  color: white;\r\n  padding: 20px 40px;\r\n  border: 3px solid #0ff;\r\n  border-radius: 10px;\r\n  animation: glow 2s infinite ease-in-out;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes glow {\r\n  0%,\r\n  100% {\r\n    box-shadow: 0 0 5px #0ff, 0 0 10px #0ff, 0 0 20px #0ff;\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 10px #0ff, 0 0 20px #0ff, 0 0 30px #0ff;\r\n  }\r\n}\r\n\r\n.animated-heading {\r\n  display: inline-block;\r\n  position: relative;\r\n  font-size: 32px;\r\n  color: #333;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.animated-heading::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  height: 3px;\r\n  width: 100%;\r\n  background: linear-gradient(90deg, #ff416c, #ff4b2b, #ff416c);\r\n  background-size: 200% 100%;\r\n  animation: border-slide 3s linear infinite;\r\n}\r\n\r\n@keyframes border-slide {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  100% {\r\n    background-position: 200% 50%;\r\n  }\r\n}\r\n\r\n.modal-90w {\r\n  max-width: 90% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
